/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	global.SPScript = __webpack_require__(1);
	global.natp = {};
	global.natp.components = __webpack_require__(9);
	global.natp.utils = __webpack_require__(3);
	global.natp.modals = __webpack_require__(15);
	global.natp.jsom = __webpack_require__(33);
	
	global.natp.onload = __webpack_require__(38);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// var promisePolyfill = require("es6-promise");
	var promisePolyfill = __webpack_require__(50);
	
	if (!global.Promise) {
		global.Promise = promisePolyfill;
	}
	var SPScript = {};
	SPScript.RestDao = __webpack_require__(62);
	SPScript.queryString = __webpack_require__(22);
	SPScript.templating = __webpack_require__(19);
	SPScript.templating.renderTemplate = SPScript.templating.render;
	SPScript.utils = __webpack_require__(2);
	SPScript.ajax = __webpack_require__(20);
	SPScript.CSR = __webpack_require__(57);
	SPScript.headers = __webpack_require__(5);
	module.exports = global.SPScript = SPScript;
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	* @namespace SPScript.utils
	*/
	
	var isBrowser = exports.isBrowser = function () {
		return !(typeof window === 'undefined');
	};
	/**
	 * If you pass in string, it will try to run JSON.parse(). The SPScript get() and post() methods already run the response through this method, so you'd really only need this if you are doing a manual ajax request. Different browsers handle JSON response differently so it is safest to call this method if you aren't going through SPScript.
	 * @param {string} data - Raw response from JSON request
	 * @returns {object} - JSON parsed object. Returns null if JSON.parse fails
	 * @function parseJSON
	 * @memberof SPScript.utils
	 * @example
	 * dao.executeRequest('/web/contentTypes')
	 *		.then(SPScript.utils.parseJSON)
	 *		.then(function(data) { console.log(data.d.results)})
	 */
	var parseJSON = exports.parseJSON = function (data) {
		if (typeof data === "string") {
			try {
				data = JSON.parse(data);
			} catch (e) {
				return null;
			}
		}
		return data;
	};
	
	/**
	 * Helps parse raw json response to remove ceremonious OData data.d namespace. Tries JSON.parse() and then pulling out actual result from data.d or data.d.results
	 * @function validateODataV2
	 * @memberof SPScript.utils
	 * @param {string|object} data - Raw response from JSON request
	 * @returns {object} - JSON parsed object with that removes data.d OData structure 
	 * @example
	 * dao.get('/web/contentTypes')
	 *		.then(SPScript.utils.validateODataV2)
	 *		.then(function(contentTypes) { console.log(contentTypes)})
	 */
	var validateODataV2 = exports.validateODataV2 = function (data) {
		var results = parseJSON(data);
		if (data.d && data.d.results && data.d.results.length != null) {
			results = data.d.results;
		} else if (data.d) {
			results = data.d;
		}
		return results;
	};
	
	//'Borrowed' from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Bitwise_Operators
	var arrayFromBitMask = exports.arrayFromBitMask = function (nMask) {
		// nMask must be between -2147483648 and 2147483647
		if (typeof nMask === "string") {
			nMask = parseInt(nMask);
		}
		// if (nMask > 0x7fffffff || nMask < -0x80000000) {
		// 	throw new TypeError("arrayFromMask - out of range");
		// }
		for (var nShifted = nMask, aFromMask = []; nShifted; aFromMask.push(Boolean(nShifted & 1)), nShifted >>>= 1) {}
		return aFromMask;
	};
	
	var _waitForLibraries = function _waitForLibraries(namespaces, resolve) {
		var missing = namespaces.filter(function (namespace) {
			return !validateNamespace(namespace);
		});
	
		if (missing.length === 0) resolve();else setTimeout(function () {
			return _waitForLibraries(namespaces, resolve);
		}, 25);
	};
	
	/**
	 * A method to allow you to wait for script dependencies to load.
	 * @param {Array} namespaces - An array of global namespaces, things on the global 'window'. For example, when jQuery is on the page, window.jQuery is valid.  So 'jQuery' is the namespace.
	 * @returns {Promise} - A Promise that resolves when all your namespaces are on the page
	 * @function waitForLibraries
	 * @memberof SPScript.utils
	 * @example
	 * function doMyStuff() { };
	 * SPScript.utils.waitForLibraries(["jQuery", "SP.UI.Dialog"]).then(doMyStuff);
	 */
	var waitForLibraries = exports.waitForLibraries = function (namespaces) {
		return new Promise(function (resolve, reject) {
			return _waitForLibraries(namespaces, resolve);
		});
	};
	
	/**
	 * A method to allow you to wait for a single script dependency to load.
	 * @param {string} namespace - A global namespace. For example, when jQuery is on the page, window.jQuery is valid. So 'jQuery' is the namespace.
	 * @returns {Promise} - A Promise that resolves when all your namespace is on the page
	 * @function waitForLibrary
	 * @memberof SPScript.utils
	 * @example
	 * function doMyStuff() { };
	 * SPScript.utils.waitForLibrary("jQuery").then(doMyStuff);
	 */
	var waitForLibrary = exports.waitForLibrary = function (namespace) {
		return waitForLibraries([namespace]);
	};
	
	/**
	 * A method to check if a given namespace is on the global object (window).
	 * @param {string} namespace - A global namespace
	 * @returns {Bool} - True or False if the namespace is on the page
	 * @function validateNamespace
	 * @memberof SPScript.utils
	 * @example
	 * var canUseModals = SPScript.utils.validateNamespace("SP.UI.Dialog");
	 */
	var validateNamespace = exports.validateNamespace = function (namespace) {
		var scope = window;
		var sections = namespace.split(".");
		var sectionsLength = sections.length;
		for (var i = 0; i < sectionsLength; i++) {
			var prop = sections[i];
			if (prop in scope) {
				scope = scope[prop];
			} else {
				return false;
			}
		}
		return true;
	};
	
	/**
	 * A method to load a javascript file onto your page
	 * @param {Array<string>} urls - An Array of urls to javascript files you want to load on your page
	 * @returns {Promise} - A Promise that resolves when all the files are done loading
	 * @function getScripts
	 * @memberof SPScript.utils
	 * @example
	 * function doMyStuff() { };
	 * var momentjsUrl = "https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.13.0/moment.min.js"
	 * var jQueryUrl = "https://cdnjs.cloudflare.com/ajax/libs/jquery/2.2.3/jquery.min.js"
	 * SPScript.utils.getScript([momentjsUrl, jQueryUrl]).then(doMyStuff);
	 */
	var getScripts = exports.getScripts = function (urls) {
		return Promise.all(urls.map(getScript));
	};
	
	/**
	 * A method to load a javascript file onto your page
	 * @param {string} url - Url to the java script file you want to load
	 * @returns {Promise} - A Promise that resolves when the file is done loading
	 * @function getScript
	 * @memberof SPScript.utils
	 * @example
	 * function doMyStuff() { };
	 * var momentjsUrl = "https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.13.0/moment.min.js"
	 * SPScript.utils.getScript(momentjsUrl).then(doMyStuff);
	 */
	var getScript = exports.getScript = function (url) {
		return new Promise(function (resolve, reject) {
			var scriptTag = window.document.createElement("script");
			var firstScriptTag = document.getElementsByTagName('script')[0];
			scriptTag.async = 1;
			firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
	
			scriptTag.onload = scriptTag.onreadystatechange = function (arg, isAbort) {
				// if its been aborted, readyState is gone, or readyState is in a 'done' status
				if (isAbort || !scriptTag.readyState || /loaded|complete/.test(scriptTag.readyState)) {
					//clean up
					scriptTag.onload = scriptTag.onreadystatechange = null;
					scriptTag = undefined;
	
					// resolve/reject the promise
					if (!isAbort) resolve();else reject;
				}
			};
			scriptTag.src = url;
		});
	};
	
	var getArrayBuffer = exports.getArrayBuffer = function (file) {
		if (file && file instanceof File) {
			return new Promise(function (resolve, reject) {
				var reader = new FileReader();
				reader.onload = function (e) {
					resolve(e.target.result);
				};
				reader.readAsArrayBuffer(file);
			});
		} else {
			throw "SPScript.utils.getArrayBuffer: Cant get ArrayBuffer if you don't pass in a file";
		}
	};
	var loadCss = exports.loadCss = function (url) {
		var link = document.createElement("link");
		link.setAttribute("rel", "stylesheet");
		link.setAttribute("type", "text/css");
		link.setAttribute("href", url);
		document.querySelector("head").appendChild(link);
	};
	
	var handleErrorResponse = exports.handleErrorResponse = function (err, res) {
		console.log("REQUEST ERROR - " + err.statusCode || err.code);
		var msg = err.body;
		try {
			var data = err.body;
			if (typeof data === "string") data = JSON.parse(err.body);
			if (data.error) msg = data.error.message.value;
		} catch (ex) {}
		console.log(msg);
		return err;
	};
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var SPScript = __webpack_require__(1);
	var cache = __webpack_require__(17);
	
	var utils = {};
	//static helper methods
	
	utils.isAuthenticated = function () {
		return window._spPageContextInfo.systemUserKey;
	};
	
	utils.isWindowsUser = function () {
		return window._spPageContextInfo.systemUserKey && window._spPageContextInfo.systemUserKey.indexOf('i:0).w|') !== -1;
	};
	
	utils.isPage = function (page) {
		return window.location.href.toLowerCase().indexOf(page.toLowerCase()) > -1;
	};
	
	utils.isInIFrame = function () {
		return self != top;
	};
	
	utils.getRootDao = function () {
		return new SPScript.RestDao(_spPageContextInfo.siteAbsoluteUrl);
	};
	
	utils.getFolderPath = function () {
		return "/Style Library/_natptax";
	};
	
	utils.getUserProfile = function () {
		var cacheKey = _spPageContextInfo.systemUserKey ? "profile_" + _spPageContextInfo.systemUserKey : "invalid cache key";
		var cacheVal = cache.get(cacheKey);
		if (!cacheVal) {
			return new SPScript.RestDao().profiles.current().then(function (p) {
				console.log(p);
				return cache.set(cacheKey, p);
			});
		} else {
			return Promise.resolve(cacheVal);
		}
	};
	
	module.exports = utils;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = jQuery;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var utils = __webpack_require__(2);
	
	var jsonMimeType = exports.jsonMimeType = "application/json;odata=verbose";
	var getStandardHeaders = exports.getStandardHeaders = function (digest) {
		var headers = {
			"Accept": jsonMimeType,
			"Content-Type": jsonMimeType
		};
		if (digest) headers["X-RequestDigest"] = digest;
		return headers;
	};
	
	exports.getAddHeaders = getStandardHeaders;
	
	var getFilestreamHeaders = exports.getFilestreamHeaders = function (digest) {
		return {
			'Accept': jsonMimeType,
			'X-RequestDigest': digest,
			'Content-Type': "application/octet-stream",
			'binaryStringRequestBody': "true"
		};
	};
	
	var getActionHeaders = exports.getActionHeaders = function (verb, digest) {
		if (!verb) return getStandardHeaders(digest);
		return _extends({}, getStandardHeaders(digest), {
			"X-HTTP-Method": verb
		});
	};
	
	var decorateETag = function decorateETag(headers, etag) {
		if (etag) headers["If-Match"] = etag;
		return headers;
	};
	
	exports.getUpdateHeaders = function (digest, etag) {
		return decorateETag(getActionHeaders("MERGE", digest), etag);
	};
	exports.getDeleteHeaders = function (digest, etag) {
		return decorateETag(getActionHeaders("DELETE", digest), etag);
	};
	//# sourceMappingURL=requestHeaders.js.map

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.ensureCtx = function (ctx) {
		return ctx || SP.ClientContext.get_current();
	};
	
	// Promisify
	var executeBatch = exports.executeBatch = function (ctx) {
		return new Promise(function (resolve, reject) {
			return ctx.executeQueryAsync(resolve, reject);
		});
	};
	
	// Collections come back super wonky and complex.  Turn them into a generic js array
	exports.collectionToArray = function (collection, mapper) {
		var enumerator = collection.getEnumerator();
		var array = [];
		while (enumerator.moveNext()) {
			var item = enumerator.get_current();
			if (mapper && typeof mapper === "function") {
				item = mapper(item);
			}
			array.push(item);
		}
		return array;
	};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var components = {};
	
	components.myAccount = __webpack_require__(10);
	components.loginPage = __webpack_require__(30);
	components.teaserContent = __webpack_require__(12);
	components.footer = __webpack_require__(26);
	components.loginModal = __webpack_require__(29);
	components.breadcrumb = __webpack_require__(25);
	components.breadcrumbPublisher = __webpack_require__(23);
	components.searchBox = __webpack_require__(11);
	components.topNav = __webpack_require__(13);
	components.header = __webpack_require__(27);
	
	module.exports = components;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// Pull in template as a string by using webpack html-loader(html!)
	var containerHtml = __webpack_require__(47);
	var template = __webpack_require__(48);
	var templating = __webpack_require__(1).templating;
	
	var api = __webpack_require__(31);
	var $ = __webpack_require__(4);
	
	var selectors = {
		container: "#natp-myaccount",
		trigger: "#myaccount-trigger"
	};
	var create = function create(containerSelector) {
		containerSelector = containerSelector || selectors.container;
		var actions = {
			close: function close() {
				$(selectors.container).removeClass("open").parent().removeClass("open").find("i.fa").removeClass("fa-chevron-down").addClass("fa-chevron-right");
			},
			open: function open() {
				$(selectors.container).addClass("open").parent().addClass("open").find("i.fa").removeClass("fa-chevron-right").addClass("fa-chevron-down");
			}
		};
		var component = { actions: actions, $container: $(containerSelector) };
	
		// Render "loading" link that will be overwritten when query comes back
		component.linkGroups = [{ links: { Display: "Loading...", URL: "#" } }];
	
		component.init = function () {
			component.renderContainer();
			component.render();
	
			$(selectors.trigger).on("click", function (e) {
				e.stopPropagation();
				$(document).trigger("header-section-toggle", component);
			});
			api.getLinks().then(function (linkGroups) {
				component.linkGroups = linkGroups;
				component.render();
			});
			api.getName().then(function (n) {
				return $("#myaccount-greeting").text("Hi, " + n);
			});
		};
	
		// Render component container
		component.renderContainer = function () {
			component.$container.html(containerHtml);
			// component.$container = $(selectors.container);
		};
	
		// Render component links
		component.render = function () {
			var myAccountContainer = document.querySelector("#natp-login-myAccountLinks");
			var html = templating.render(template, component);
	
			if (myAccountContainer) {
				myAccountContainer.innerHTML = html;
			}
		};
	
		component.init();
		return component;
	};
	
	module.exports = { create: create };

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var $ = __webpack_require__(4);
	
	var selectors = {
		trigger: "#search-trigger",
		container: ".natp-search-container"
	};
	
	var triggerHtml = "\n<div class='header-trigger' id='" + selectors.trigger.replace("#", "") + "'\">\n\t<i class=\"glyphicon glyphicon-search\"></i>\n\t<span>SEARCH</span>\n</div> \n";
	
	var create = function create(containerSelector) {
		containerSelector = containerSelector || selectors.container;
	
		var actions = {
			close: function close() {
				return component.$container.removeClass("open");
			},
			open: function open() {
				return component.$container.addClass("open");
			}
		};
		var component = { actions: actions, $container: $(containerSelector) };
	
		// add the trigger
		component.$container.prepend(triggerHtml);
	
		$(selectors.trigger).on("click", function (e) {
			e.stopPropagation();
			$(document).trigger("header-section-toggle", component);
		});
	
		return component;
	};
	
	module.exports = { create: create };

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// Tell webpack to include your component specific css
	__webpack_require__(68);
	var SPScript = __webpack_require__(1);
	var lists = __webpack_require__(18);
	
	// Pull in template as a string by using html-loader(html!)
	
	// if there is no 'teaserUrl' querystring param, show nothing
	// if there is a queryString param, query list to find teaser content
	// if there is no match, show default teaser content
	var templating = __webpack_require__(1).templating;
	var normalizeUrl = function normalizeUrl(url) {
		return encodeURI(decodeURI(url.toLowerCase()));
	};
	
	var defaultItem = {
		TeaserContent: "<H2>Create an account</H2>"
	};
	var create = function create(containerSelector) {
		var component = {};
		component.container = document.querySelector(containerSelector);
		var qs = SPScript.queryString.toObj(window.location.search);
	
		component.init = function () {
			if (qs.teaserUrl) {
				component.teaserUrl = normalizeUrl(qs.teaserUrl);
				component.getTeaserContent().then(component.render);
			}
		};
	
		component.getTeaserContent = function () {
			return lists.TeaserContent.getItems("$select=TeaserUrl,TeaserContent").then(function (items) {
				var specificItemTeaser = items.filter(function (i) {
					return normalizeUrl(i.TeaserUrl) === normalizeUrl(component.teaserUrl);
				}); // find a url match
				var defaultItemTeaser = items.filter(function (i) {
					return i.TeaserUrl === "default";
				}); // find the default item from list
	
				return specificItemTeaser.length && specificItemTeaser[0] || defaultItemTeaser.length && defaultItemTeaser[0] || defaultItem; // use hardcoded default item
			});;
		};
	
		component.render = function (item) {
			if (component.container && item.TeaserContent) {
				component.container.innerHTML = item.TeaserContent;
			}
		};
	
		component.init();
		return component;
	};
	
	module.exports = { create: create };

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var selectors = __webpack_require__(32);
	var triggerHtml = "<div class='header-trigger' id='" + selectors.trigger.replace("#", "") + "'>\n    <i class=\"fa fa-bars\"></i>\n    <span>Menu</span>\n</div>";
	
	var dropdownArrow = "<span class='header-dropdownArrow'></span>";
	
	var actions = {
	    close: function close(e) {
	        $(selectors.menuWrapper).removeClass("open");
	        // wait to close submenu until slide left is done
	        setTimeout(function () {
	            return $(selectors.activeHeaders).removeClass("active");
	        }, 300);
	    },
	    open: function open() {
	        $(selectors.menuWrapper).toggleClass("open");
	    },
	    dropdownToggle: function dropdownToggle(e) {
	        e.preventDefault();
	        e.stopPropagation();
	        var $this = $(this);
	        var isActive = $this.parent().hasClass("active");
	        $(selectors.activeHeaders).removeClass("active");
	        if (!isActive) $this.parent().addClass("active");
	    }
	};
	
	var create = function create(container, triggerClick) {
	    container = container || selectors.menuWrapper;
	
	    var component = { actions: actions, $container: $(container) };
	    // Add the menu trigger
	    component.$container.addClass('header-section').prepend(triggerHtml);
	    // set a max height on dropdown menus for mobile scrolling. shouldn't effect desktop
	    $(selectors.dropdownMenu).css("max-height", window.innerHeight - 70 + "px");
	
	    // Add the menu dropdown arrows
	    $(selectors.headers + " > a.menu-item").after(dropdownArrow);
	    $(selectors.trigger).on("click", function (e) {
	        e.stopPropagation();
	        $(document).trigger("header-section-toggle", component);
	    });
	    //expand sub menus on click
	    //$(selectors.headers).on("click", actions.dropdownToggle);
	    $(selectors.headers + " > .header-dropdownArrow").on("click", actions.dropdownToggle);
	    // allow links to redirect as normal
	    $(selectors.dropdownLinks).on("click", function (e) {
	        return e.stopPropagation();
	    });
	
	    return component;
	};
	
	module.exports = { create: create };

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(8);
	var SPScript = __webpack_require__(1);
	// returns flat list of terms
	var getTerms = exports.getTerms = function (termSetId, ctx) {
	    var _arguments = arguments;
	
	    ctx = utils.ensureCtx(ctx);
	    return getTermStore(ctx).then(function (store) {
	        var termCollection = store.getTermSet(termSetId).getAllTerms();
	        ctx.load(termCollection);
	        return utils.executeBatch(ctx).then(function () {
	            return utils.collectionToArray(termCollection, Term.fromSPTerm);
	        });
	    }).catch(function () {
	        return console.log(_arguments);
	    });
	};
	
	var Term = function Term() {
	    this.name = "", this.id = "", this.path = "", this.childCount = 0;
	    this.children = [];
	    this.props = {};
	    this.sortOrder = 0;
	};
	
	Term.fromSPTerm = function (spTerm) {
	    var term = new Term();
	    if (spTerm) {
	        term.name = spTerm.get_name();
	        term.id = spTerm.get_id();
	        if (term.id._m_guidString$p$0) term.id = term.id._m_guidString$p$0;
	        term.path = spTerm.get_pathOfTerm();
	        term.childCount = spTerm.get_termsCount();
	        term.sortOrder = spTerm.get_customSortOrder() || 0;
	        term.props = spTerm.get_localCustomProperties();
	    }
	    return term;
	};
	
	// Efficient group algorithm based on sorting by path
	var groupTerms = exports.groupTerms = function (flatTerms) {
	    var terms = [];
	    var activeTerm;
	    var sortComp = function sortComp(a, b) {
	        if (a.path < b.path) return -1;
	        if (a.path > b.path) return 1;
	        return 0;
	    };
	
	    var sortedTerms = flatTerms.slice(0).sort(sortComp);
	    var i = 0;
	
	    var populateTerm = function populateTerm() {
	        var term = sortedTerms[i];
	        //if there isn't a next term return OR if the next term doesn't start with the current term's path
	        i = i + 1;
	        while (i < sortedTerms.length && sortedTerms[i].path.startsWith(term.path)) {
	            term.children.push(populateTerm());
	        }
	        return term;
	    };
	
	    while (i < sortedTerms.length) {
	        terms.push(populateTerm());
	    }
	    return terms;
	};
	
	var getTermStore = exports.getTermStore = function (ctx) {
	    return SPScript.utils.waitForLibraries(["SP", "SP.ClientContext", "sp_runtime_initialize"]).then(function () {
	        if (!SPScript.utils.validateNamespace("SP.Taxonomy")) {
	            return SPScript.utils.getScript(_spPageContextInfo.webAbsoluteUrl + "/_layouts/15/sp.taxonomy.js");
	        }
	        return true;
	    }).then(function () {
	        return SP.Taxonomy.TaxonomySession.getTaxonomySession(utils.ensureCtx(ctx)).getDefaultSiteCollectionTermStore();
	    });
	};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(35);
	__webpack_require__(69);
	
	var ensureIsDlg = function ensureIsDlg(url) {
	    if (url.toLowerCase().indexOf("isdlg") === -1) {
	        var prefix = url.indexOf("?") === -1 ? "?" : "&";
	        url += prefix + "isDlg=1";
	    }
	    return url;
	};
	var promise = null;
	
	var launch = exports.launch = function (url) {
	    //clean up any existing modals by closing it and resolving with a CANCEL
	    close();
	
	    return new Promise(function (resolve, reject) {
	        promise = { resolve: resolve, reject: reject };
	        url = ensureIsDlg(url);
	        var frameHeight = window.innerHeight - 60;
	        frameHeight = frameHeight < 700 ? frameHeight : 700;
	        var frameWidth = window.innerWidth - 60;
	        frameWidth = frameWidth < 715 ? frameWidth : 715;
	        jQuery.modal("<iframe src=\"" + url + "\" height=\"" + frameHeight + "\" width=\"" + frameWidth + "\" style=\"border:0\">", {
	            containerCss: {
	                backgroundColor: "#fff",
	                borderColor: "#fff",
	                padding: 0,
	                height: frameHeight + 10,
	                width: frameWidth + 10
	            },
	            closeHTML: '<a class="modalCloseImg" title="Close"></a>',
	            overlayClose: true,
	            escClose: true,
	            modal: true,
	            onClose: _close
	        });
	    });
	};
	
	var _close = function _close(e) {
	    close({ status: 0 });
	};
	
	var close = exports.close = function (result) {
	    if (promise) promise.resolve(result);
	    jQuery.modal.close();
	    promise = null;
	};

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.setup = function () {
	
	    /*
	    (function (i, s, o, g, r, a, m) {
	        i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
	            (i[r].q = i[r].q || []).push(arguments)
	        }, i[r].l = 1 * new Date(); a = s.createElement(o),
	            m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
	    })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
	      ga('create', 'UA-55283808-1', 'natptax.com');
	    ga('require', 'displayfeatures');
	    ga('send', 'pageview');
	    ga('create', 'UA-50234938-1', 'auto', { 'name': 'newTracker' });  // New tracker.
	    ga('newTracker.send', 'pageview'); // Send page view for new tracker.
	      */
	};
	
	exports.trackClick = function (event) {
	    /*
	     var filetypes = /\.(zip|exe|dmg|pdf|doc.*|xls.*|ppt.*|mp3|txt|rar|wma|mov|avi|wmv|flv|wav)$/i;
	     var baseHref = '';
	     if (jQuery('base').attr('href') != undefined) baseHref = jQuery('base').attr('href');
	       var el = jQuery(this);
	     var track = true;
	     var href = (typeof (el.attr('href')) != 'undefined') ? el.attr('href') : "";
	     var isThisDomain = href.match(document.domain.split('.').reverse()[1] + '.' + document.domain.split('.').reverse()[0]);
	     if (!href.match(/^javascript:/i)) {
	         var elEv = []; elEv.value = 0, elEv.non_i = false;
	         if (href.match(/^mailto\:/i)) {
	             elEv.category = "email";
	             elEv.action = "click";
	             elEv.label = href.replace(/^mailto\:/i, '');
	             elEv.loc = href;
	         }
	         else if (href.match(filetypes)) {
	             var extension = (/[.]/.exec(href)) ? /[^.]+$/.exec(href) : undefined;
	             elEv.category = "download";
	             elEv.action = "click-" + extension[0];
	             elEv.label = href.replace(/ /g, "-");
	             elEv.loc = baseHref + href;
	         }
	         else if (href.match(/^http?\:/i) && !isThisDomain) {
	             elEv.category = "external";
	             elEv.action = "click";
	             elEv.label = href.replace(/^https?\:\/\//i, '');
	             elEv.non_i = true;
	             elEv.loc = href;
	         }
	         else if (href.match(/^tel\:/i)) {
	             elEv.category = "telephone";
	             elEv.action = "click";
	             elEv.label = href.replace(/^tel\:/i, '');
	             elEv.loc = href;
	         }
	         else track = false;
	           if (track) {
	             //_gaq.push(['_trackEvent', elEv.category.toLowerCase(), elEv.action.toLowerCase(), elEv.label.toLowerCase(), elEv.value, elEv.non_i]);
	             //ga(['_trackEvent', elEv.category.toLowerCase(), elEv.action.toLowerCase(), elEv.label.toLowerCase(), elEv.value, elEv.non_i]);
	               ga('send', 'event', elEv.category.toLowerCase(), elEv.action.toLowerCase(), elEv.label.toLowerCase());
	    
	             if (el.attr('target') == undefined || el.attr('target').toLowerCase() != '_blank') {
	                 setTimeout(function () { location.href = elEv.loc; }, 400);
	                 return false;
	             }
	         }
	     } 
	     */
	};

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	var cache = localStorage; // also supports 'sessionStorage'
	//var cacheDuration = (1000 * 60 * 60 * 8) //8 hours
	var cacheDuration = window.location.href.toLowerCase().indexOf('www.natptax.com') > -1 ? 1000 * 60 * 60 * 8 : 1000 * 30; //30 seconds for DEV
	
	var _isExpired = function _isExpired(cacheValue) {
		return Date.now() > cacheValue.expiration;
	};
	
	var get = exports.get = function (key) {
		var valueStr = cache.getItem(key);
		if (valueStr) {
			var val = JSON.parse(valueStr);
			return !_isExpired(val) ? val.payload : null;
		}
		return null;
	};
	
	exports.set = function (key, payload) {
		var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : cacheDuration;
	
		var expiration = Date.now() + duration;
		cache.setItem(key, JSON.stringify({ payload: payload, expiration: expiration }));
		return get(key);
	};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var RestDao = __webpack_require__(1).RestDao;
	
	var _getList = function _getList(listname) {
		return new RestDao(_spPageContextInfo.siteAbsoluteUrl).lists(listname);
	};
	
	// var lists = {
	// 	get LinksMyAccount (){
	// 		return _getList("LinksMyAccount");
	// 	}
	// };
	
	var listNames = ["LinksMyAccount", "TeaserContent"];
	
	var lists = {};
	
	listNames.forEach(function (name) {
		Object.defineProperty(lists, name, {
			get: _getList.bind(null, name)
		});
	});
	
	module.exports = lists;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * mustache.js - Logic-less {{mustache}} templates with JavaScript
	 * http://github.com/janl/mustache.js
	 */
	
	/*global define: false Mustache: true*/
	
	(function defineMustache (global, factory) {
	  if (typeof exports === 'object' && exports && typeof exports.nodeName !== 'string') {
	    factory(exports); // CommonJS
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // AMD
	  } else {
	    global.Mustache = {};
	    factory(global.Mustache); // script, wsh, asp
	  }
	}(this, function mustacheFactory (mustache) {
	
	  var objectToString = Object.prototype.toString;
	  var isArray = Array.isArray || function isArrayPolyfill (object) {
	    return objectToString.call(object) === '[object Array]';
	  };
	
	  function isFunction (object) {
	    return typeof object === 'function';
	  }
	
	  /**
	   * More correct typeof string handling array
	   * which normally returns typeof 'object'
	   */
	  function typeStr (obj) {
	    return isArray(obj) ? 'array' : typeof obj;
	  }
	
	  function escapeRegExp (string) {
	    return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
	  }
	
	  /**
	   * Null safe way of checking whether or not an object,
	   * including its prototype, has a given property
	   */
	  function hasProperty (obj, propName) {
	    return obj != null && typeof obj === 'object' && (propName in obj);
	  }
	
	  // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
	  // See https://github.com/janl/mustache.js/issues/189
	  var regExpTest = RegExp.prototype.test;
	  function testRegExp (re, string) {
	    return regExpTest.call(re, string);
	  }
	
	  var nonSpaceRe = /\S/;
	  function isWhitespace (string) {
	    return !testRegExp(nonSpaceRe, string);
	  }
	
	  var entityMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '/': '&#x2F;',
	    '`': '&#x60;',
	    '=': '&#x3D;'
	  };
	
	  function escapeHtml (string) {
	    return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap (s) {
	      return entityMap[s];
	    });
	  }
	
	  var whiteRe = /\s*/;
	  var spaceRe = /\s+/;
	  var equalsRe = /\s*=/;
	  var curlyRe = /\s*\}/;
	  var tagRe = /#|\^|\/|>|\{|&|=|!/;
	
	  /**
	   * Breaks up the given `template` string into a tree of tokens. If the `tags`
	   * argument is given here it must be an array with two string values: the
	   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
	   * course, the default is to use mustaches (i.e. mustache.tags).
	   *
	   * A token is an array with at least 4 elements. The first element is the
	   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
	   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
	   * all text that appears outside a symbol this element is "text".
	   *
	   * The second element of a token is its "value". For mustache tags this is
	   * whatever else was inside the tag besides the opening symbol. For text tokens
	   * this is the text itself.
	   *
	   * The third and fourth elements of the token are the start and end indices,
	   * respectively, of the token in the original template.
	   *
	   * Tokens that are the root node of a subtree contain two more elements: 1) an
	   * array of tokens in the subtree and 2) the index in the original template at
	   * which the closing tag for that section begins.
	   */
	  function parseTemplate (template, tags) {
	    if (!template)
	      return [];
	
	    var sections = [];     // Stack to hold section tokens
	    var tokens = [];       // Buffer to hold the tokens
	    var spaces = [];       // Indices of whitespace tokens on the current line
	    var hasTag = false;    // Is there a {{tag}} on the current line?
	    var nonSpace = false;  // Is there a non-space char on the current line?
	
	    // Strips all whitespace tokens array for the current line
	    // if there was a {{#tag}} on it and otherwise only space.
	    function stripSpace () {
	      if (hasTag && !nonSpace) {
	        while (spaces.length)
	          delete tokens[spaces.pop()];
	      } else {
	        spaces = [];
	      }
	
	      hasTag = false;
	      nonSpace = false;
	    }
	
	    var openingTagRe, closingTagRe, closingCurlyRe;
	    function compileTags (tagsToCompile) {
	      if (typeof tagsToCompile === 'string')
	        tagsToCompile = tagsToCompile.split(spaceRe, 2);
	
	      if (!isArray(tagsToCompile) || tagsToCompile.length !== 2)
	        throw new Error('Invalid tags: ' + tagsToCompile);
	
	      openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
	      closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
	      closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
	    }
	
	    compileTags(tags || mustache.tags);
	
	    var scanner = new Scanner(template);
	
	    var start, type, value, chr, token, openSection;
	    while (!scanner.eos()) {
	      start = scanner.pos;
	
	      // Match any text between tags.
	      value = scanner.scanUntil(openingTagRe);
	
	      if (value) {
	        for (var i = 0, valueLength = value.length; i < valueLength; ++i) {
	          chr = value.charAt(i);
	
	          if (isWhitespace(chr)) {
	            spaces.push(tokens.length);
	          } else {
	            nonSpace = true;
	          }
	
	          tokens.push([ 'text', chr, start, start + 1 ]);
	          start += 1;
	
	          // Check for whitespace on the current line.
	          if (chr === '\n')
	            stripSpace();
	        }
	      }
	
	      // Match the opening tag.
	      if (!scanner.scan(openingTagRe))
	        break;
	
	      hasTag = true;
	
	      // Get the tag type.
	      type = scanner.scan(tagRe) || 'name';
	      scanner.scan(whiteRe);
	
	      // Get the tag value.
	      if (type === '=') {
	        value = scanner.scanUntil(equalsRe);
	        scanner.scan(equalsRe);
	        scanner.scanUntil(closingTagRe);
	      } else if (type === '{') {
	        value = scanner.scanUntil(closingCurlyRe);
	        scanner.scan(curlyRe);
	        scanner.scanUntil(closingTagRe);
	        type = '&';
	      } else {
	        value = scanner.scanUntil(closingTagRe);
	      }
	
	      // Match the closing tag.
	      if (!scanner.scan(closingTagRe))
	        throw new Error('Unclosed tag at ' + scanner.pos);
	
	      token = [ type, value, start, scanner.pos ];
	      tokens.push(token);
	
	      if (type === '#' || type === '^') {
	        sections.push(token);
	      } else if (type === '/') {
	        // Check section nesting.
	        openSection = sections.pop();
	
	        if (!openSection)
	          throw new Error('Unopened section "' + value + '" at ' + start);
	
	        if (openSection[1] !== value)
	          throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
	      } else if (type === 'name' || type === '{' || type === '&') {
	        nonSpace = true;
	      } else if (type === '=') {
	        // Set the tags for the next time around.
	        compileTags(value);
	      }
	    }
	
	    // Make sure there are no open sections when we're done.
	    openSection = sections.pop();
	
	    if (openSection)
	      throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
	
	    return nestTokens(squashTokens(tokens));
	  }
	
	  /**
	   * Combines the values of consecutive text tokens in the given `tokens` array
	   * to a single token.
	   */
	  function squashTokens (tokens) {
	    var squashedTokens = [];
	
	    var token, lastToken;
	    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
	      token = tokens[i];
	
	      if (token) {
	        if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
	          lastToken[1] += token[1];
	          lastToken[3] = token[3];
	        } else {
	          squashedTokens.push(token);
	          lastToken = token;
	        }
	      }
	    }
	
	    return squashedTokens;
	  }
	
	  /**
	   * Forms the given array of `tokens` into a nested tree structure where
	   * tokens that represent a section have two additional items: 1) an array of
	   * all tokens that appear in that section and 2) the index in the original
	   * template that represents the end of that section.
	   */
	  function nestTokens (tokens) {
	    var nestedTokens = [];
	    var collector = nestedTokens;
	    var sections = [];
	
	    var token, section;
	    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
	      token = tokens[i];
	
	      switch (token[0]) {
	        case '#':
	        case '^':
	          collector.push(token);
	          sections.push(token);
	          collector = token[4] = [];
	          break;
	        case '/':
	          section = sections.pop();
	          section[5] = token[2];
	          collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
	          break;
	        default:
	          collector.push(token);
	      }
	    }
	
	    return nestedTokens;
	  }
	
	  /**
	   * A simple string scanner that is used by the template parser to find
	   * tokens in template strings.
	   */
	  function Scanner (string) {
	    this.string = string;
	    this.tail = string;
	    this.pos = 0;
	  }
	
	  /**
	   * Returns `true` if the tail is empty (end of string).
	   */
	  Scanner.prototype.eos = function eos () {
	    return this.tail === '';
	  };
	
	  /**
	   * Tries to match the given regular expression at the current position.
	   * Returns the matched text if it can match, the empty string otherwise.
	   */
	  Scanner.prototype.scan = function scan (re) {
	    var match = this.tail.match(re);
	
	    if (!match || match.index !== 0)
	      return '';
	
	    var string = match[0];
	
	    this.tail = this.tail.substring(string.length);
	    this.pos += string.length;
	
	    return string;
	  };
	
	  /**
	   * Skips all text until the given regular expression can be matched. Returns
	   * the skipped string, which is the entire tail if no match can be made.
	   */
	  Scanner.prototype.scanUntil = function scanUntil (re) {
	    var index = this.tail.search(re), match;
	
	    switch (index) {
	      case -1:
	        match = this.tail;
	        this.tail = '';
	        break;
	      case 0:
	        match = '';
	        break;
	      default:
	        match = this.tail.substring(0, index);
	        this.tail = this.tail.substring(index);
	    }
	
	    this.pos += match.length;
	
	    return match;
	  };
	
	  /**
	   * Represents a rendering context by wrapping a view object and
	   * maintaining a reference to the parent context.
	   */
	  function Context (view, parentContext) {
	    this.view = view;
	    this.cache = { '.': this.view };
	    this.parent = parentContext;
	  }
	
	  /**
	   * Creates a new context using the given view with this context
	   * as the parent.
	   */
	  Context.prototype.push = function push (view) {
	    return new Context(view, this);
	  };
	
	  /**
	   * Returns the value of the given name in this context, traversing
	   * up the context hierarchy if the value is absent in this context's view.
	   */
	  Context.prototype.lookup = function lookup (name) {
	    var cache = this.cache;
	
	    var value;
	    if (cache.hasOwnProperty(name)) {
	      value = cache[name];
	    } else {
	      var context = this, names, index, lookupHit = false;
	
	      while (context) {
	        if (name.indexOf('.') > 0) {
	          value = context.view;
	          names = name.split('.');
	          index = 0;
	
	          /**
	           * Using the dot notion path in `name`, we descend through the
	           * nested objects.
	           *
	           * To be certain that the lookup has been successful, we have to
	           * check if the last object in the path actually has the property
	           * we are looking for. We store the result in `lookupHit`.
	           *
	           * This is specially necessary for when the value has been set to
	           * `undefined` and we want to avoid looking up parent contexts.
	           **/
	          while (value != null && index < names.length) {
	            if (index === names.length - 1)
	              lookupHit = hasProperty(value, names[index]);
	
	            value = value[names[index++]];
	          }
	        } else {
	          value = context.view[name];
	          lookupHit = hasProperty(context.view, name);
	        }
	
	        if (lookupHit)
	          break;
	
	        context = context.parent;
	      }
	
	      cache[name] = value;
	    }
	
	    if (isFunction(value))
	      value = value.call(this.view);
	
	    return value;
	  };
	
	  /**
	   * A Writer knows how to take a stream of tokens and render them to a
	   * string, given a context. It also maintains a cache of templates to
	   * avoid the need to parse the same template twice.
	   */
	  function Writer () {
	    this.cache = {};
	  }
	
	  /**
	   * Clears all cached templates in this writer.
	   */
	  Writer.prototype.clearCache = function clearCache () {
	    this.cache = {};
	  };
	
	  /**
	   * Parses and caches the given `template` and returns the array of tokens
	   * that is generated from the parse.
	   */
	  Writer.prototype.parse = function parse (template, tags) {
	    var cache = this.cache;
	    var tokens = cache[template];
	
	    if (tokens == null)
	      tokens = cache[template] = parseTemplate(template, tags);
	
	    return tokens;
	  };
	
	  /**
	   * High-level method that is used to render the given `template` with
	   * the given `view`.
	   *
	   * The optional `partials` argument may be an object that contains the
	   * names and templates of partials that are used in the template. It may
	   * also be a function that is used to load partial templates on the fly
	   * that takes a single argument: the name of the partial.
	   */
	  Writer.prototype.render = function render (template, view, partials) {
	    var tokens = this.parse(template);
	    var context = (view instanceof Context) ? view : new Context(view);
	    return this.renderTokens(tokens, context, partials, template);
	  };
	
	  /**
	   * Low-level method that renders the given array of `tokens` using
	   * the given `context` and `partials`.
	   *
	   * Note: The `originalTemplate` is only ever used to extract the portion
	   * of the original template that was contained in a higher-order section.
	   * If the template doesn't use higher-order sections, this argument may
	   * be omitted.
	   */
	  Writer.prototype.renderTokens = function renderTokens (tokens, context, partials, originalTemplate) {
	    var buffer = '';
	
	    var token, symbol, value;
	    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
	      value = undefined;
	      token = tokens[i];
	      symbol = token[0];
	
	      if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate);
	      else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate);
	      else if (symbol === '>') value = this.renderPartial(token, context, partials, originalTemplate);
	      else if (symbol === '&') value = this.unescapedValue(token, context);
	      else if (symbol === 'name') value = this.escapedValue(token, context);
	      else if (symbol === 'text') value = this.rawValue(token);
	
	      if (value !== undefined)
	        buffer += value;
	    }
	
	    return buffer;
	  };
	
	  Writer.prototype.renderSection = function renderSection (token, context, partials, originalTemplate) {
	    var self = this;
	    var buffer = '';
	    var value = context.lookup(token[1]);
	
	    // This function is used to render an arbitrary template
	    // in the current context by higher-order sections.
	    function subRender (template) {
	      return self.render(template, context, partials);
	    }
	
	    if (!value) return;
	
	    if (isArray(value)) {
	      for (var j = 0, valueLength = value.length; j < valueLength; ++j) {
	        buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate);
	      }
	    } else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') {
	      buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate);
	    } else if (isFunction(value)) {
	      if (typeof originalTemplate !== 'string')
	        throw new Error('Cannot use higher-order sections without the original template');
	
	      // Extract the portion of the original template that the section contains.
	      value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
	
	      if (value != null)
	        buffer += value;
	    } else {
	      buffer += this.renderTokens(token[4], context, partials, originalTemplate);
	    }
	    return buffer;
	  };
	
	  Writer.prototype.renderInverted = function renderInverted (token, context, partials, originalTemplate) {
	    var value = context.lookup(token[1]);
	
	    // Use JavaScript's definition of falsy. Include empty arrays.
	    // See https://github.com/janl/mustache.js/issues/186
	    if (!value || (isArray(value) && value.length === 0))
	      return this.renderTokens(token[4], context, partials, originalTemplate);
	  };
	
	  Writer.prototype.renderPartial = function renderPartial (token, context, partials) {
	    if (!partials) return;
	
	    var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
	    if (value != null)
	      return this.renderTokens(this.parse(value), context, partials, value);
	  };
	
	  Writer.prototype.unescapedValue = function unescapedValue (token, context) {
	    var value = context.lookup(token[1]);
	    if (value != null)
	      return value;
	  };
	
	  Writer.prototype.escapedValue = function escapedValue (token, context) {
	    var value = context.lookup(token[1]);
	    if (value != null)
	      return mustache.escape(value);
	  };
	
	  Writer.prototype.rawValue = function rawValue (token) {
	    return token[1];
	  };
	
	  mustache.name = 'mustache.js';
	  mustache.version = '2.3.0';
	  mustache.tags = [ '{{', '}}' ];
	
	  // All high-level mustache.* functions use this writer.
	  var defaultWriter = new Writer();
	
	  /**
	   * Clears all cached templates in the default writer.
	   */
	  mustache.clearCache = function clearCache () {
	    return defaultWriter.clearCache();
	  };
	
	  /**
	   * Parses and caches the given template in the default writer and returns the
	   * array of tokens it contains. Doing this ahead of time avoids the need to
	   * parse templates on the fly as they are rendered.
	   */
	  mustache.parse = function parse (template, tags) {
	    return defaultWriter.parse(template, tags);
	  };
	
	  /**
	   * Renders the `template` with the given `view` and `partials` using the
	   * default writer.
	   */
	  mustache.render = function render (template, view, partials) {
	    if (typeof template !== 'string') {
	      throw new TypeError('Invalid template! Template should be a "string" ' +
	                          'but "' + typeStr(template) + '" was given as the first ' +
	                          'argument for mustache#render(template, view, partials)');
	    }
	
	    return defaultWriter.render(template, view, partials);
	  };
	
	  // This is here for backwards compatibility with 0.4.x.,
	  /*eslint-disable */ // eslint wants camel cased function name
	  mustache.to_html = function to_html (template, view, partials, send) {
	    /*eslint-enable*/
	
	    var result = mustache.render(template, view, partials);
	
	    if (isFunction(send)) {
	      send(result);
	    } else {
	      return result;
	    }
	  };
	
	  // Export the escaping function so that the user may override it.
	  // See https://github.com/janl/mustache.js/issues/244
	  mustache.escape = escapeHtml;
	
	  // Export these mainly for testing, but also for advanced usage.
	  mustache.Scanner = Scanner;
	  mustache.Context = Context;
	  mustache.Writer = Writer;
	
	  return mustache;
	}));


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	* @namespace SPScript.ajax
	*/
	
	var defaults = {
		method: "GET",
		async: true,
		type: "json", //XMLHttpRequest.responseType
		data: undefined
	};
	
	var validMethods = ["GET", "POST", "PUT", "HEAD", "DELETE", "PATCH"];
	
	var errorHandlers = [];
	
	var validateOptions = function validateOptions(options) {
		if (!options || !options.url || validMethods.indexOf(options.method) < 0) return false;else return true;
	};
	
	var setHeaders = function setHeaders(xhr, headersObj) {
		if (headersObj) {
			Object.keys(headersObj).forEach(function (key) {
				xhr.setRequestHeader(key, headersObj[key]);
			});
		}
	};
	
	/**
	 * Performs and AJAX request based on options you pass you. Your options must at least have a url.
	 * @param {object} options - Request options like { url, headers, method };
	 * @returns {Promise} - A ES6 Promise that resolves or rejects when the request comes back
	 * @function ajax
	 * @memberof SPScript.ajax
	 * @example
	 * var ajaxOptions = { 
	 *    url: '/_api/web/contentTypes', 
	 *    method: "GET", 
	 *    headers: { Accept: "application/json;odata=verbose" } 
	 * };
	 * SPScript.utils.ajax(ajaxOptions)
	 *		.then(SPScript.utils.parseJSON)
	 *		.then(function(data){ console.log(data.d.results) })
	 *		.catch(function(error) { console.log(error)})
	 */
	var ajax = function ajax(options) {
		var opts = _extends({}, defaults, options);
		if (!validateOptions(options)) return Promise.reject(new Error("Invalid options passed into ajax call."));
	
		var xhr = new XMLHttpRequest();
		if (xhr == null) return Promise.reject(new Error("Your browser doesn't support XMLHttpRequest (ajax)."));
	
		xhr.open(opts.method, opts.url, opts.async);
		setHeaders(xhr, opts.headers);
		xhr.responseType = opts.type;
	
		return new Promise(function (resolve, reject) {
			xhr.onreadystatechange = function () {
				//completed
				if (xhr.readyState === 4) {
					// SUCCESS
					if (xhr.status < 400 && xhr.status >= 100) {
						resolve(xhr.response);
					} else {
						var error = new Error("AJAX Request Error: Response Code = " + xhr.status);
						error.statusCode = xhr.status;
						error.body = xhr.response;
						errorHandlers.forEach(function (fn) {
							return fn(error, xhr);
						});
						reject(error);
					}
				}
			};
	
			xhr.send(opts.data);
		});
	};
	
	ajax.addErrorHandler = function (fn) {
		return errorHandlers.push(fn);
	};
	ajax.setDefaults = function (options) {
		return _extends(defaults, options);
	};
	
	module.exports = ajax;
	//# sourceMappingURL=ajax.js.map

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(2);
	
	/**
	 * Allows you to to check on the security of a list or site. You shouldn't be creating instances of the this class, you will get it from the Web or List class.
	 * @class
	 * @param {string} baseUrl - Url to the securable
	 * @param {IBaseDao} dao - Data access object used to make requests.
	 * @example <caption>Access Permissions class using the 'permissions' property on a Web</caption>
	 * var dao = new SPScript.RestDao(_spPageContextInfo.webAbsoluteUrl);
	 *
	 * dao.web.permissions.getRoleAssignments()
	 *     .then(function(roleAssignments) { console.log(roleAssignments) });
	 * @example <caption>Access Permissions class using the 'permissions' property on a List</caption>
	 * dao.lists("Restricted Library").permissions.getRoleAssignments()
	 *     .then(function(roleAssignments) { console.log(roleAssignments) });
	 */
	var Permissions = function Permissions(baseUrl, dao) {
	   this._dao = dao;
	   this.baseUrl = baseUrl;
	};
	
	/**
	 * Gets all the role assignments on that securable
	 * @returns {Promise<Array<RoleAssignment>>} - A Promise that resolves to an array of role assignments
	 * @example
	 * dao.web.permissions.getRoleAssignments()
	 *     .then(function(roleAssignments) { console.log(roleAssignments) });
	 */
	Permissions.prototype.getRoleAssignments = function () {
	   var url = this.baseUrl + "/RoleAssignments?$expand=Member,RoleDefinitionBindings";
	   return this._dao.get(url).then(utils.validateODataV2).then(function (results) {
	      return results.map(transforms.roleAssignment);
	   });
	};
	
	/**
	 * Gets all the role assignments on that securable. If you don't pass an email, it will use the current user.
	 * @param {string} [email] - If you don't pass an email it will use current user
	 * @returns {Promise<Array>} - A Promise that resolves to an array of string base permission values
	 * @example <caption>Get the current users permissions on a site</caption>
	 * dao.web.permissions.check()
	 *     .then(function(basePermissions) { console.log(basePermissions) });
	 * @example <caption>Get a specified user's permissions on a list</caption>
	 * var email = "andrew@andrewpetersen.onmicrosoft.com"
	 * dao.lists("Restricted Library").permissions.check(email)
	 *     .then(function(basePermissions) { console.log(basePermissions) });
	 */
	Permissions.prototype.check = function (email) {
	   var _this = this;
	
	   var checkPrivs = function checkPrivs(user) {
	      var login = encodeURIComponent(user.LoginName);
	      var url = _this.baseUrl + "/getusereffectivepermissions(@v)?@v='" + login + "'";
	      return _this._dao.get(url).then(utils.validateODataV2);
	   };
	
	   //if no email, and no current user id, reject
	   if (!email && !utils.isBrowser()) {
	      return Promise.reject("Can't Check Permissions.  No email passed and no current user");
	   }
	
	   // If no email is passed, then get current user, else get user by email
	   var req = !email ? this._dao.get('/web/getuserbyid(' + _spPageContextInfo.userId + ')').then(function (data) {
	      return data.d;
	   }) : this._dao.web.getUser(email);
	
	   return req.then(checkPrivs).then(function (privs) {
	      return permissionMaskToStrings(privs.GetUserEffectivePermissions.Low, privs.GetUserEffectivePermissions.High);
	   });
	};
	
	/**
	 * Represents a permission on the securable
	 * @typedef {Object} RoleMember
	 * @property {string} login - Login Name
	 * @property {string} name - User or Group title
	 * @property {string} id - Member Id
	 */
	
	/**
	 * Represents a permission on the securable
	 * @typedef {Object} RoleDef
	 * @property {string} name - Role Definition name
	 * @property {string} description - Role Definition description
	 * @property {Array} basePermissions - Array of base permission strings
	 */
	
	/**
	 * Represents a permission on the securable
	 * @typedef {Object} RoleAssignment
	 * @property {RoleMember} member - User or group
	 * @property {Array<RoleDef>} roles - An array of role definitions
	 */
	var transforms = {
	   roleAssignment: function roleAssignment(raw) {
	      var priv = {
	         member: {
	            login: raw.Member.LoginName,
	            name: raw.Member.Title,
	            id: raw.Member.Id
	         }
	      };
	      priv.roles = raw.RoleDefinitionBindings.results.map(function (roleDef) {
	         return {
	            name: roleDef.Name,
	            description: roleDef.Description,
	            basePermissions: permissionMaskToStrings(roleDef.BasePermissions.Low, roleDef.BasePermissions.High)
	         };
	      });
	      return priv;
	   }
	};
	
	var permissionMaskToStrings = function permissionMaskToStrings(lowMask, highMask) {
	   var basePermissions = [];
	   spBasePermissions.forEach(function (basePermission) {
	      if ((basePermission.low & lowMask) > 0 || (basePermission.high & highMask) > 0) {
	         basePermissions.push(basePermission.name);
	      }
	   });
	   return basePermissions;
	};
	
	// Scraped it from SP.PermissionKind.
	// Storing it in here to remove sp.js dependency
	
	// var basePermissions = [];
	// Object.keys(SP.PermissionKind).forEach(function(key) {
	// 	var perm = new SP.BasePermissions();
	//     perm.set(SP.PermissionKind[key]);
	//     var permisison = {
	//     	name: key,
	//     	low: perm.$A_1,
	//     	high: perm.$9_1
	//     };
	//     basePermissions.push(permisison);
	// });
	
	var spBasePermissions = [{
	   "name": "emptyMask",
	   "low": 0,
	   "high": 0
	}, {
	   "name": "viewListItems",
	   "low": 1,
	   "high": 0
	}, {
	   "name": "addListItems",
	   "low": 2,
	   "high": 0
	}, {
	   "name": "editListItems",
	   "low": 4,
	   "high": 0
	}, {
	   "name": "deleteListItems",
	   "low": 8,
	   "high": 0
	}, {
	   "name": "approveItems",
	   "low": 16,
	   "high": 0
	}, {
	   "name": "openItems",
	   "low": 32,
	   "high": 0
	}, {
	   "name": "viewVersions",
	   "low": 64,
	   "high": 0
	}, {
	   "name": "deleteVersions",
	   "low": 128,
	   "high": 0
	}, {
	   "name": "cancelCheckout",
	   "low": 256,
	   "high": 0
	}, {
	   "name": "managePersonalViews",
	   "low": 512,
	   "high": 0
	}, {
	   "name": "manageLists",
	   "low": 2048,
	   "high": 0
	}, {
	   "name": "viewFormPages",
	   "low": 4096,
	   "high": 0
	}, {
	   "name": "anonymousSearchAccessList",
	   "low": 8192,
	   "high": 0
	}, {
	   "name": "open",
	   "low": 65536,
	   "high": 0
	}, {
	   "name": "viewPages",
	   "low": 131072,
	   "high": 0
	}, {
	   "name": "addAndCustomizePages",
	   "low": 262144,
	   "high": 0
	}, {
	   "name": "applyThemeAndBorder",
	   "low": 524288,
	   "high": 0
	}, {
	   "name": "applyStyleSheets",
	   "low": 1048576,
	   "high": 0
	}, {
	   "name": "viewUsageData",
	   "low": 2097152,
	   "high": 0
	}, {
	   "name": "createSSCSite",
	   "low": 4194304,
	   "high": 0
	}, {
	   "name": "manageSubwebs",
	   "low": 8388608,
	   "high": 0
	}, {
	   "name": "createGroups",
	   "low": 16777216,
	   "high": 0
	}, {
	   "name": "managePermissions",
	   "low": 33554432,
	   "high": 0
	}, {
	   "name": "browseDirectories",
	   "low": 67108864,
	   "high": 0
	}, {
	   "name": "browseUserInfo",
	   "low": 134217728,
	   "high": 0
	}, {
	   "name": "addDelPrivateWebParts",
	   "low": 268435456,
	   "high": 0
	}, {
	   "name": "updatePersonalWebParts",
	   "low": 536870912,
	   "high": 0
	}, {
	   "name": "manageWeb",
	   "low": 1073741824,
	   "high": 0
	}, {
	   "name": "anonymousSearchAccessWebLists",
	   "low": -2147483648,
	   "high": 0
	}, {
	   "name": "useClientIntegration",
	   "low": 0,
	   "high": 16
	}, {
	   "name": "useRemoteAPIs",
	   "low": 0,
	   "high": 32
	}, {
	   "name": "manageAlerts",
	   "low": 0,
	   "high": 64
	}, {
	   "name": "createAlerts",
	   "low": 0,
	   "high": 128
	}, {
	   "name": "editMyUserInfo",
	   "low": 0,
	   "high": 256
	}, {
	   "name": "enumeratePermissions",
	   "low": 0,
	   "high": 1073741824
	}];
	
	module.exports = Permissions;
	//# sourceMappingURL=permissions.js.map

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var qs = __webpack_require__(53);
	
	/**
	* @namespace SPScript.queryString
	*/
	
	/**
	 * Turns a normal js Object into a string in form of "key1=value1&key2=value2..."
	 * @param {Object} obj - Javascript object to query stringify
	 * @param {bool} [[quoteValues]] - By default, if the value has a space, it will be single quoted. Passing true will cause all values to be quoted.
	 * @returns {string} - Note: tt does NOT prepend '?' char
	 * @function fromObj
	 * @memberof SPScript.queryString
	 * @example
	 * var myObj = { id: 123, title: "My Title" }
	 * var qs = SPScript.queryString.fromObj(myObj);
	 * // qs would output: "id=123&title='MyTitle'"
	 */
	var fromObj = exports.fromObj = function (obj, quoteValues) {
	
	  var writeParam = function writeParam(key) {
	    var value = (obj[key] + "").trim();
	    // if there is a space, wrap in single quotes
	    if (value.indexOf(" ") > -1 || quoteValues) value = "'" + value + "'";
	
	    return key + "=" + value;
	  };
	
	  var str = Object.keys(obj).map(writeParam).join("&");
	  return str;
	};
	
	/**
	 * Turns a string in form of "key1=value1&key2=value2..." into a javascript object
	 * @param {string} str - must be in query string format to work
	 * @returns {Object} - A javascript object with properties for each key found in the query string passed in.
	 * @function toObj
	 * @memberof SPScript.queryString
	 * @example
	 * // your url is "https://sharepoint.com/sites/mysite/home.aspx?id=123&title='My Title'"
	 * var myObj = SPScript.queryString.toObj(window.location.search);
	 * //myObj would be { id: 123, title: "My Title" }
	 */
	var toObj = exports.toObj = function (str) {
	  //if no string is passed use window.location.search
	  if (str === undefined && window && window.location && window.location.search) {
	    str = window.location.search;
	  }
	  if (!str) return {};
	  //trim off the leading '?' if its there
	  if (str[0] === "?") str = str.substr(1);
	
	  return qs.parse(str);
	};
	
	exports.contains = function (key, text) {
	  return toObj(text).hasOwnProperty(key);
	};
	exports.getValue = function (key, text) {
	  return toObj(text)[key] || "";
	};
	//# sourceMappingURL=queryString.js.map

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// Tell webpack to include your component specific css
	var mms = __webpack_require__(14);
	var utils = __webpack_require__(3);
	var $ = __webpack_require__(4);
	
	var selectors = {
		buttonContainer: "#OKCancelSection",
		btnPublish: "#btn-breadcrumb-publish",
		termsetId: "#ItemId",
		termsetName: "#ItemName",
		termGroupName: "#ctl00_PlaceHolderMain_groupName",
		leftPanel: "#TmtContentTable .leftarea"
	};
	
	var btnHtml = "<input \n\t\tid='btn-breadcrumb-publish'\n\t\tstyle='float:right'\n\t\ttype=\"button\" value=\"Publish\" \n\t\tclass=\"ms-ButtonHeightWidth\" />";
	
	var create = function create() {
		var component = {};
		var dao = utils.getRootDao();
	
		component.publishBreadcrumb = function () {
			var _arguments = arguments;
	
			// Get the termset id from the DOM
			var termsetId = document.querySelector(selectors.termsetId).innerHTML;
			// Get a flattened list of all the terms
			mms.getTerms(termsetId, SP.ClientContext.get_current())
			// Group the terms
			.then(mms.groupTerms)
			// Save to style library as breadcrumb.json
			.then(function (breadcrumb) {
				var fileContents = JSON.stringify(breadcrumb);
				var file = {
					folder: utils.getFolderPath(),
					name: "breadcrumb.txt"
				};
				file.path = file.folder + "/" + file.name;
	
				return dao.web.fileAction(file.path, "checkout").then(function () {
					return dao.web.uploadFile(fileContents, file.folder, { name: file.name });
				}).then(function () {
					return dao.web.fileAction(file.path, "checkin", { checkInType: 1 });
				}).then(function () {
					return console.log("Successfully updatesd " + file.path);
				}).catch(function () {
					return console.log(_arguments);
				});
			});
		};
	
		component.render = function () {
			var btn = document.querySelector(selectors.btnPublish);
			var $container = $(selectors.buttonContainer);
			var shouldShow = component.shouldShow();
	
			// If the button is on the page, but shouldn't show
			if (btn && !shouldShow) {
				// Remove the button
				$container[0].removeChild(btn);
			}
			// If the button is not on the page and should show
			else if (!btn && shouldShow && $container.length) {
					// render the button and add a click event
					$container.append(btnHtml);
					$(selectors.btnPublish).on("click", component.publishBreadcrumb);;
				}
		};
	
		component.bindEvents = function () {
			$(selectors.leftPanel).on("click", component.render);
		};
	
		component.shouldShow = function () {
			return $(selectors.termsetName).text() === "Breadcrumb";
		};
	
		setTimeout(function () {
			component.render();
			component.bindEvents();
		}, 1);
		return component;
	};
	
	module.exports = { create: create };

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var SPScript = __webpack_require__(1);
	var utils = __webpack_require__(3);
	
	var cache = __webpack_require__(17);
	var cacheKey = "natp-breadcrumb";
	
	// Public function that first tries to get it from cache
	exports.getBreadcrumbTermId = function () {
	    if (_spPageContextInfo && _spPageContextInfo.pageListId && _spPageContextInfo.pageItemId) {
	        var listId = _spPageContextInfo.pageListId;
	        var itemId = _spPageContextInfo.pageItemId;
	        // create new DAO using subsite's url
	        var key = createPageCacheKey(listId, itemId);
	        var cachedValue = cache.get(key);
	        if (cachedValue) return Promise.resolve(cachedValue);
	        return fetchBreadcrumbTermId(listId, itemId).then(function (id) {
	            return cache.set(key, id);
	        });
	    }
	    // Can't query for breadcrumb context so return empty value so it won't render
	    return Promise.resolve("");
	};
	
	var createPageCacheKey = function createPageCacheKey(listId, itemId) {
	    return "page-breadcrumb-value-" + listId + "-" + itemId;
	};
	
	var fetchBreadcrumbTermId = function fetchBreadcrumbTermId(listId, itemId) {
	    var dao = new SPScript.RestDao(_spPageContextInfo.webAbsoluteUrl);
	    var url = "/lists('" + listId + "')/items('" + itemId + "')?$select=NATPBreadcrumb";
	
	    return dao.get(url).then(SPScript.utils.validateODataV2).then(function (item) {
	        return item && item.NATPBreadcrumb ? item.NATPBreadcrumb.TermGuid : "";
	    });
	};
	
	// Public function that first tries to get it from cache
	exports.getFullBreadcrumb = function () {
	    var cachedValue = cache.get(cacheKey);
	    if (cachedValue) return Promise.resolve(cachedValue);
	    return fetchFullBreadcrumb().then(function (b) {
	        return cache.set(cacheKey, b);
	    });
	};
	
	var fetchFullBreadcrumb = function fetchFullBreadcrumb() {
	    var url = utils.getFolderPath() + "/breadcrumb.txt";
	    return SPScript.ajax({ url: url, method: "GET" }).then(function (res) {
	        return typeof res === "string" ? JSON.parse(res) : res;
	    });
	};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var SPScript = __webpack_require__(1);
	__webpack_require__(65);
	
	var data = __webpack_require__(24);
	var create = function create(containerSelector) {
		var component = {};
		component.container = document.querySelector(containerSelector);
		component.fullBreadcrumb = [];
		component.breadcrumbTermId = "";
		component.init = function () {
			data.getFullBreadcrumb().then(function (b) {
				return component.fullBreadcrumb = b;
			}).then(data.getBreadcrumbTermId).then(function (id) {
				return component.breadcrumbTermId = id;
			}).then(getBreadcrumbPath).then(component.render);
		};
	
		var getBreadcrumbPath = function getBreadcrumbPath() {
			if (!component.breadcrumbTermId) return [];
			var path = [];
			var matchedPath = null;
			var findMatch = function findMatch(term) {
				path.push(term);
				if (term.id === component.breadcrumbTermId) {
					matchedPath = path.slice(0);
				}
				term.children.forEach(findMatch);
				path.pop();
			};
			component.fullBreadcrumb.forEach(findMatch);
			return matchedPath || [];
		};
	
		// Render the main guts of the component right away
		component.render = function (breadcrumbTerms) {
			var html = breadcrumbTerms.map(function (t) {
				// if there is a url, render an anchor tag, otherwise just text
				var innerElement = t.props.Url ? "<a href='" + t.props.Url + "'>" + t.name + "</a>" : t.name;
				return "<span class='breadcrumb-item " + (t.props.CssClass || "") + "'>" + innerElement + "</span>";
			}).join("");
	
			if (component.container) {
				component.container.innerHTML = html;
				component.container.className += " ready";
			}
		};
		SPScript.utils.waitForLibrary("_spPageContextInfo.pageListId").then(component.init);
		return component;
	};
	
	module.exports = { create: create };

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/* ======= Usage ==========
	 * To add to a page, add the following script
	 * natp.components.footer.create(selector);
	 * ========================
	*/
	
	// Tell webpack to include your component specific css
	__webpack_require__(66);
	
	var create = function create(containerSelector) {
		var component = {};
		component.container = document.querySelector(containerSelector);
	
		// Render the main guts of the component right away
		component.render = function (html) {
			if (component.container) {
				component.container.innerHTML = html;
			}
		};
		// $.get('https://da79a07c.ngrok.io/assets/Style%20Library/_natptax/footer.html')
		$.get(_spPageContextInfo.siteAbsoluteUrl + '/Style%20Library/_natptax/footer.html').then(component.render);
	
		return component;
	};
	
	module.exports = { create: create };

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var topNav = __webpack_require__(13);
	var searchBox = __webpack_require__(11);
	var myAccount = __webpack_require__(10);
	var loginDropdown = __webpack_require__(28);
	var utils = __webpack_require__(3);
	
	var actions = {
	    closeItems: function closeItems() {
	        components.topNav.actions.close();
	        components.search.actions.close();
	        components.myAccount.actions.close();
	    }
	};
	
	var components = {};
	var create = function create() {
	    components.topNav = topNav.create("#menu-wrap");
	    components.search = searchBox.create();
	    //Render MyAccount Links (Logged-in ONLY)
	    if (utils.isAuthenticated()) {
	        components.myAccount = myAccount.create('.natp-login-container');
	    } else {
	        components.myAccount = loginDropdown.create('.natp-login-container');
	    }
	    bindEvents();
	};
	
	var bindEvents = function bindEvents() {
	    $("body").on("click", function (e) {
	        if (!$(e.target).hasClass("header-dropdown") && !$(e.target).closest(".header-dropdown").length && !$(e.target).hasClass("natp-login-dropdown") && !$(e.target).closest(".natp-login-dropdown").length) {
	            actions.closeItems();
	        }
	    });
	
	    // TODO: implement this
	    //  $('#natp-login-dropdownBtn').on("click", (e) => {
	    //      //Check to see if the dropdown is open. If not, wait and check again.
	    //      setTimeout(function() {
	    //          if ($("#natp-login-dropdownContainer").hasClass("open"))
	    //         {	
	    //             var $userInputBox = $(".natp-login-dropdown-menu").find(".natpUserNameTextBox").find("input:text");
	    //             $userInputBox.focus();
	    //         }
	    //      }, 100);
	    // });
	
	
	    $(document).on("header-section-toggle", function (e, component) {
	        var isOpen = component.$container.hasClass("open");
	        console.log(isOpen);
	        actions.closeItems();
	        if (!isOpen) component.actions.open();
	    });
	};
	module.exports = { create: create };

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(3);
	var containerHtml = __webpack_require__(45);
	
	var $ = __webpack_require__(4);
	var loginFooter = __webpack_require__(46);
	
	var selectors = {
		container: ".natp-login-container",
		form: ".natp-login-form",
		dropdownContainer: ".header-dropdown",
		trigger: "#login-trigger",
		errorLabel: ".natpLoginError"
	};
	
	var create = function create(containerSelector) {
		containerSelector = containerSelector || selectors.container;
	
		var actions = {
			close: function close() {
				return component.$container.removeClass("open");
			},
			open: function open() {
				return component.$container.addClass("open");
			}
		};
		var component = { actions: actions, $container: $(containerSelector) };
		component.$container.html(containerHtml);
	
		$(selectors.trigger).on("click", function (e) {
			e.stopPropagation();
			$(document).trigger("header-section-toggle", component);
		});
	
		if (window.location.pathname.toLowerCase() === "/pages/login.aspx") {
			$(selectors.dropdownContainer).css("padding", 0);
		} else {
			$(selectors.form).appendTo(containerSelector + " " + selectors.dropdownContainer);
			$(selectors.form).append(loginFooter);
	
			if (component.$container.find(selectors.errorLabel).text().length) {
				setTimeout(function () {
					return $(selectors.trigger).click();
				}, 200);
			}
		}
		return component;
	};
	
	module.exports = { create: create };

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(4);
	var queryString = __webpack_require__(1).queryString;
	var teaserContent = __webpack_require__(12);
	
	var create = function create(containerSelector) {
		var qs = queryString.toObj();
		if (qs.loginSuccess && window.top) {
			window.top.natp.modals.close({ status: 1 });
		}
	
		var selectors = {
			container: "#loginModal-container",
			form: ".natp-login-form"
		};
		setTimeout(function () {
			var $container = $(selectors.container);
			$container.html("");
			console.log("HERE!");
			$(selectors.form).appendTo(selectors.container);
			$(selectors.form).show();
	
			$container.append("<div class='natp-teaser-container'></div>");
			teaserContent.create(".natp-teaser-container");
		}, 1);
	
		// setTimeout(() => {
		// 	var $container = $(containerSelector);
		// 	var $loginContainer = $(".natp-login-container");
		// 	var $loginForm = $loginContainer.find(".natp-login-form");
	
		// 	$container.append($loginForm);
	
		// 	$container
	
		// 	setTimeout(() => $loginContainer.remove(), 1);
		// }, 1);
	};
	
	module.exports = { create: create };

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var $ = __webpack_require__(4);
	var utils = __webpack_require__(3);
	__webpack_require__(67);
	var create = function create(selector) {
	
		// TODO: show message saying they are already logged in or redirect
		if (utils.isAuthenticated()) {
			var html = "<p>\n\t\t\tYou're already logged in. Click\n\t\t\t<a title=\"Log Out\" href=\"/_layouts/15/NATPAuth/Logout.aspx\" target=\"_self\"> here </a>\n\t\t\tto log out.\n\t\t</p>";
			$("#login-page-content").html(html);
		}
	
		var selectors = {
			formContainer: ".login-page-form-container",
			form: ".natp-login-form"
		};
		setTimeout(function () {
			$(selectors.formContainer).html("");
			$(".natp-login-form").appendTo(selectors.formContainer);
			$(".natp-login-form").show();
		}, 1);
	};
	
	module.exports = { create: create };

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var lists = __webpack_require__(18);
	var utils = __webpack_require__(3);
	
	var transformLinkItem = function transformLinkItem(linkItem) {
		return {
			Display: linkItem.Title,
			URL: linkItem.URL,
			SortOrder: linkItem.SortOrder,
			LinkTarget: linkItem.OpenInNewTab ? "_blank" : "_self"
		};
	};
	
	var groupLinks = function groupLinks() {
		var listItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
		// Use an object map for 'linkGroups' to avoid array lookups
		var linkGroups = {};
		listItems.forEach(function (item) {
			if (!linkGroups[item.Group]) {
				linkGroups[item.Group] = { GroupName: item.Group, links: [] };
			}
			linkGroups[item.Group].links.push(transformLinkItem(item));
		});
		// Turn the object into an array, sort the object keys before mapping to avoid custom sort function
		return Object.keys(linkGroups).sort().map(function (key) {
			return linkGroups[key];
		});
	};
	
	// Public
	exports.getLinks = function () {
		var odata = "$select=Title,URL,SortOrder,Group,OpenInNewTab&$orderby=SortOrder,Title";
		return lists.LinksMyAccount.getItems(odata).then(groupLinks);
	};
	
	exports.getName = function () {
		return utils.getUserProfile().then(function (p) {
			return p.FirstName || p.PreferredName || p.DisplayName || p.UserName;
		});
	};

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	    menuWrapper: "#menu-wrap",
	    trigger: "#menu-trigger",
	    menuId: "#myTopNav",
	    aspMenuId: "#zz13_RootAspMenu, #zz2_RootAspMenu",
	    headers: ".ms-core-listMenu-root > li.static > ul.static > li.dynamic-children",
	    activeHeaders: ".ms-core-listMenu-root > li.static > ul.static > li.dynamic-children.active",
	    dropdownMenu: "html.natp #menu-wrap ul.ms-core-listMenu-root > li.static > ul.static",
	    dropdownLinks: ".ms-core-listMenu-root > li.static > ul.static > li.dynamic-children ul.dynamic a"
	};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var jsom = _extends({}, __webpack_require__(8));
	jsom.mms = __webpack_require__(14);
	jsom.webProperties = __webpack_require__(34);
	
	module.exports = jsom;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(8);
	
	exports.set = function (key, value) {
					var ctx = utils.ensureCtx();
					var web = ctx.get_web();
					var propBag = web.get_allProperties();
					propBag.set_item(key, value + "");
					ctx.load(web);
					ctx.load(propBag);
					web.update();
	
					return utils.executeBatch(ctx).then(function () {
									return console.log("Success - Set " + key + " to " + value);
					}).catch(function () {
									return console.log("Failed to set " + key + " property");
					});
	};
	
	exports.get = function (key) {
					// look at the property bag of the current spweb
					ctx = ctx || SP.ClientContext.get_current();
					var web = ctx.get_web();
					var propBag = web.get_allProperties();
	
					ctx.load(web);
					ctx.load(propBag);
	
					return utils.executeBatch(ctx).then(function () {
									var props = propBag.get_fieldValues();
									if (key) return props[key];
									return props;
					});
	};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	 * SimpleModal 1.4.4 - jQuery Plugin
	 * http://simplemodal.com/
	 * Copyright (c) 2013 Eric Martin
	 * Licensed under MIT and GPL
	 * Date: Sun, Jan 20 2013 15:58:56 -0800
	 */
	
	/**
	 * SimpleModal is a lightweight jQuery plugin that provides a simple
	 * interface to create a modal dialog.
	 *
	 * The goal of SimpleModal is to provide developers with a cross-browser
	 * overlay and container that will be populated with data provided to
	 * SimpleModal.
	 *
	 * There are two ways to call SimpleModal:
	 * 1) As a chained function on a jQuery object, like $('#myDiv').modal();.
	 * This call would place the DOM object, #myDiv, inside a modal dialog.
	 * Chaining requires a jQuery object. An optional options object can be
	 * passed as a parameter.
	 *
	 * @example $('<div>my data</div>').modal({options});
	 * @example $('#myDiv').modal({options});
	 * @example jQueryObject.modal({options});
	 *
	 * 2) As a stand-alone function, like $.modal(data). The data parameter
	 * is required and an optional options object can be passed as a second
	 * parameter. This method provides more flexibility in the types of data
	 * that are allowed. The data could be a DOM object, a jQuery object, HTML
	 * or a string.
	 *
	 * @example $.modal('<div>my data</div>', {options});
	 * @example $.modal('my data', {options});
	 * @example $.modal($('#myDiv'), {options});
	 * @example $.modal(jQueryObject, {options});
	 * @example $.modal(document.getElementById('myDiv'), {options});
	 *
	 * A SimpleModal call can contain multiple elements, but only one modal
	 * dialog can be created at a time. Which means that all of the matched
	 * elements will be displayed within the modal container.
	 *
	 * SimpleModal internally sets the CSS needed to display the modal dialog
	 * properly in all browsers, yet provides the developer with the flexibility
	 * to easily control the look and feel. The styling for SimpleModal can be
	 * done through external stylesheets, or through SimpleModal, using the
	 * overlayCss, containerCss, and dataCss options.
	 *
	 * SimpleModal has been tested in the following browsers:
	 * - IE 6+
	 * - Firefox 2+
	 * - Opera 9+
	 * - Safari 3+
	 * - Chrome 1+
	 *
	 * @name SimpleModal
	 * @type jQuery
	 * @requires jQuery v1.3
	 * @cat Plugins/Windows and Overlays
	 * @author Eric Martin (http://ericmmartin.com)
	 * @version 1.4.4
	 */
	
	;(function (factory) {
		if (true) {
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Browser globals
			factory(jQuery);
		}
	})(function ($) {
		var d = [],
		    doc = $(document),
		    ua = navigator.userAgent.toLowerCase(),
		    wndw = $(window),
		    w = [];
	
		var browser = {
			ieQuirks: null,
			msie: /msie/.test(ua) && !/opera/.test(ua),
			opera: /opera/.test(ua)
		};
		browser.ie6 = browser.msie && /msie 6./.test(ua) && _typeof(window['XMLHttpRequest']) !== 'object';
		browser.ie7 = browser.msie && /msie 7.0/.test(ua);
	
		/*
	  * Create and display a modal dialog.
	  *
	  * @param {string, object} data A string, jQuery object or DOM object
	  * @param {object} [options] An optional object containing options overrides
	  */
		$.modal = function (data, options) {
			return $.modal.impl.init(data, options);
		};
	
		/*
	  * Close the modal dialog.
	  */
		$.modal.close = function () {
			$.modal.impl.close();
		};
	
		/*
	  * Set focus on first or last visible input in the modal dialog. To focus on the last
	  * element, call $.modal.focus('last'). If no input elements are found, focus is placed
	  * on the data wrapper element.
	  */
		$.modal.focus = function (pos) {
			$.modal.impl.focus(pos);
		};
	
		/*
	  * Determine and set the dimensions of the modal dialog container.
	  * setPosition() is called if the autoPosition option is true.
	  */
		$.modal.setContainerDimensions = function () {
			$.modal.impl.setContainerDimensions();
		};
	
		/*
	  * Re-position the modal dialog.
	  */
		$.modal.setPosition = function () {
			$.modal.impl.setPosition();
		};
	
		/*
	  * Update the modal dialog. If new dimensions are passed, they will be used to determine
	  * the dimensions of the container.
	  *
	  * setContainerDimensions() is called, which in turn calls setPosition(), if enabled.
	  * Lastly, focus() is called is the focus option is true.
	  */
		$.modal.update = function (height, width) {
			$.modal.impl.update(height, width);
		};
	
		/*
	  * Chained function to create a modal dialog.
	  *
	  * @param {object} [options] An optional object containing options overrides
	  */
		$.fn.modal = function (options) {
			return $.modal.impl.init(this, options);
		};
	
		/*
	  * SimpleModal default options
	  *
	  * appendTo:		(String:'body') The jQuery selector to append the elements to. For .NET, use 'form'.
	  * focus:			(Boolean:true) Focus in the first visible, enabled element?
	  * opacity:			(Number:50) The opacity value for the overlay div, from 0 - 100
	  * overlayId:		(String:'simplemodal-overlay') The DOM element id for the overlay div
	  * overlayCss:		(Object:{}) The CSS styling for the overlay div
	  * containerId:		(String:'simplemodal-container') The DOM element id for the container div
	  * containerCss:	(Object:{}) The CSS styling for the container div
	  * dataId:			(String:'simplemodal-data') The DOM element id for the data div
	  * dataCss:			(Object:{}) The CSS styling for the data div
	  * minHeight:		(Number:null) The minimum height for the container
	  * minWidth:		(Number:null) The minimum width for the container
	  * maxHeight:		(Number:null) The maximum height for the container. If not specified, the window height is used.
	  * maxWidth:		(Number:null) The maximum width for the container. If not specified, the window width is used.
	  * autoResize:		(Boolean:false) Automatically resize the container if it exceeds the browser window dimensions?
	  * autoPosition:	(Boolean:true) Automatically position the container upon creation and on window resize?
	  * zIndex:			(Number: 1000) Starting z-index value
	  * close:			(Boolean:true) If true, closeHTML, escClose and overClose will be used if set.
	  							If false, none of them will be used.
	  * closeHTML:		(String:'<a class="modalCloseImg" title="Close"></a>') The HTML for the default close link.
	 							SimpleModal will automatically add the closeClass to this element.
	  * closeClass:		(String:'simplemodal-close') The CSS class used to bind to the close event
	  * escClose:		(Boolean:true) Allow Esc keypress to close the dialog?
	  * overlayClose:	(Boolean:false) Allow click on overlay to close the dialog?
	  * fixed:			(Boolean:true) If true, the container will use a fixed position. If false, it will use a
	 							absolute position (the dialog will scroll with the page)
	  * position:		(Array:null) Position of container [top, left]. Can be number of pixels or percentage
	  * persist:			(Boolean:false) Persist the data across modal calls? Only used for existing
	 							DOM elements. If true, the data will be maintained across modal calls, if false,
	 							the data will be reverted to its original state.
	  * modal:			(Boolean:true) User will be unable to interact with the page below the modal or tab away from the dialog.
	 							If false, the overlay, iframe, and certain events will be disabled allowing the user to interact
	 							with the page below the dialog.
	  * onOpen:			(Function:null) The callback function used in place of SimpleModal's open
	  * onShow:			(Function:null) The callback function used after the modal dialog has opened
	  * onClose:			(Function:null) The callback function used in place of SimpleModal's close
	  */
		$.modal.defaults = {
			appendTo: 'body',
			focus: true,
			opacity: 50,
			overlayId: 'simplemodal-overlay',
			overlayCss: {},
			containerId: 'simplemodal-container',
			containerCss: {},
			dataId: 'simplemodal-data',
			dataCss: {},
			minHeight: null,
			minWidth: null,
			maxHeight: null,
			maxWidth: null,
			autoResize: false,
			autoPosition: true,
			zIndex: 1000,
			close: true,
			closeHTML: '<a class="modalCloseImg" title="Close"></a>',
			closeClass: 'simplemodal-close',
			escClose: true,
			overlayClose: false,
			fixed: true,
			position: null,
			persist: false,
			modal: true,
			onOpen: null,
			onShow: null,
			onClose: null
		};
	
		/*
	  * Main modal object
	  * o = options
	  */
		$.modal.impl = {
			/*
	   * Contains the modal dialog elements and is the object passed
	   * back to the callback (onOpen, onShow, onClose) functions
	   */
			d: {},
			/*
	   * Initialize the modal dialog
	   */
			init: function init(data, options) {
				var s = this;
	
				// don't allow multiple calls
				if (s.d.data) {
					return false;
				}
	
				// $.support.boxModel is undefined if checked earlier
				browser.ieQuirks = browser.msie && !$.support.boxModel;
	
				// merge defaults and user options
				s.o = $.extend({}, $.modal.defaults, options);
	
				// keep track of z-index
				s.zIndex = s.o.zIndex;
	
				// set the onClose callback flag
				s.occb = false;
	
				// determine how to handle the data based on its type
				if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
					// convert DOM object to a jQuery object
					data = data instanceof $ ? data : $(data);
					s.d.placeholder = false;
	
					// if the object came from the DOM, keep track of its parent
					if (data.parent().parent().size() > 0) {
						data.before($('<span></span>').attr('id', 'simplemodal-placeholder').css({ display: 'none' }));
	
						s.d.placeholder = true;
						s.display = data.css('display');
	
						// persist changes? if not, make a clone of the element
						if (!s.o.persist) {
							s.d.orig = data.clone(true);
						}
					}
				} else if (typeof data === 'string' || typeof data === 'number') {
					// just insert the data as innerHTML
					data = $('<div></div>').html(data);
				} else {
					// unsupported data type!
					alert('SimpleModal Error: Unsupported data type: ' + (typeof data === 'undefined' ? 'undefined' : _typeof(data)));
					return s;
				}
	
				// create the modal overlay, container and, if necessary, iframe
				s.create(data);
				data = null;
	
				// display the modal dialog
				s.open();
	
				// useful for adding events/manipulating data in the modal dialog
				if ($.isFunction(s.o.onShow)) {
					s.o.onShow.apply(s, [s.d]);
				}
	
				// don't break the chain =)
				return s;
			},
			/*
	   * Create and add the modal overlay and container to the page
	   */
			create: function create(data) {
				var s = this;
	
				// get the window properties
				s.getDimensions();
	
				// add an iframe to prevent select options from bleeding through
				if (s.o.modal && browser.ie6) {
					s.d.iframe = $('<iframe src="javascript:false;"></iframe>').css($.extend(s.o.iframeCss, {
						display: 'none',
						opacity: 0,
						position: 'fixed',
						height: w[0],
						width: w[1],
						zIndex: s.o.zIndex,
						top: 0,
						left: 0
					})).appendTo(s.o.appendTo);
				}
	
				// create the overlay
				s.d.overlay = $('<div></div>').attr('id', s.o.overlayId).addClass('simplemodal-overlay').css($.extend(s.o.overlayCss, {
					display: 'none',
					opacity: s.o.opacity / 100,
					height: s.o.modal ? d[0] : 0,
					width: s.o.modal ? d[1] : 0,
					position: 'fixed',
					left: 0,
					top: 0,
					zIndex: s.o.zIndex + 1
				})).appendTo(s.o.appendTo);
	
				// create the container
				s.d.container = $('<div></div>').attr('id', s.o.containerId).addClass('simplemodal-container').css($.extend({ position: s.o.fixed ? 'fixed' : 'absolute' }, s.o.containerCss, { display: 'none', zIndex: s.o.zIndex + 2 })).append(s.o.close && s.o.closeHTML ? $(s.o.closeHTML).addClass(s.o.closeClass) : '').appendTo(s.o.appendTo);
	
				s.d.wrap = $('<div></div>').attr('tabIndex', -1).addClass('simplemodal-wrap').css({ height: '100%', outline: 0, width: '100%' }).appendTo(s.d.container);
	
				// add styling and attributes to the data
				// append to body to get correct dimensions, then move to wrap
				s.d.data = data.attr('id', data.attr('id') || s.o.dataId).addClass('simplemodal-data').css($.extend(s.o.dataCss, {
					display: 'none'
				})).appendTo('body');
				data = null;
	
				s.setContainerDimensions();
				s.d.data.appendTo(s.d.wrap);
	
				// fix issues with IE
				if (browser.ie6 || browser.ieQuirks) {
					s.fixIE();
				}
			},
			/*
	   * Bind events
	   */
			bindEvents: function bindEvents() {
				var s = this;
	
				// bind the close event to any element with the closeClass class
				$('.' + s.o.closeClass).bind('click.simplemodal', function (e) {
					e.preventDefault();
					s.close();
				});
	
				// bind the overlay click to the close function, if enabled
				if (s.o.modal && s.o.close && s.o.overlayClose) {
					s.d.overlay.bind('click.simplemodal', function (e) {
						e.preventDefault();
						s.close();
					});
				}
	
				// bind keydown events
				doc.bind('keydown.simplemodal', function (e) {
					if (s.o.modal && e.keyCode === 9) {
						// TAB
						s.watchTab(e);
					} else if (s.o.close && s.o.escClose && e.keyCode === 27) {
						// ESC
						e.preventDefault();
						s.close();
					}
				});
	
				// update window size
				wndw.bind('resize.simplemodal orientationchange.simplemodal', function () {
					// redetermine the window width/height
					s.getDimensions();
	
					// reposition the dialog
					s.o.autoResize ? s.setContainerDimensions() : s.o.autoPosition && s.setPosition();
	
					if (browser.ie6 || browser.ieQuirks) {
						s.fixIE();
					} else if (s.o.modal) {
						// update the iframe & overlay
						s.d.iframe && s.d.iframe.css({ height: w[0], width: w[1] });
						s.d.overlay.css({ height: d[0], width: d[1] });
					}
				});
			},
			/*
	   * Unbind events
	   */
			unbindEvents: function unbindEvents() {
				$('.' + this.o.closeClass).unbind('click.simplemodal');
				doc.unbind('keydown.simplemodal');
				wndw.unbind('.simplemodal');
				this.d.overlay.unbind('click.simplemodal');
			},
			/*
	   * Fix issues in IE6 and IE7 in quirks mode
	   */
			fixIE: function fixIE() {
				var s = this,
				    p = s.o.position;
	
				// simulate fixed position - adapted from BlockUI
				$.each([s.d.iframe || null, !s.o.modal ? null : s.d.overlay, s.d.container.css('position') === 'fixed' ? s.d.container : null], function (i, el) {
					if (el) {
						var bch = 'document.body.clientHeight',
						    bcw = 'document.body.clientWidth',
						    bsh = 'document.body.scrollHeight',
						    bsl = 'document.body.scrollLeft',
						    bst = 'document.body.scrollTop',
						    bsw = 'document.body.scrollWidth',
						    ch = 'document.documentElement.clientHeight',
						    cw = 'document.documentElement.clientWidth',
						    sl = 'document.documentElement.scrollLeft',
						    st = 'document.documentElement.scrollTop',
						    s = el[0].style;
	
						s.position = 'absolute';
						if (i < 2) {
							s.removeExpression('height');
							s.removeExpression('width');
							s.setExpression('height', '' + bsh + ' > ' + bch + ' ? ' + bsh + ' : ' + bch + ' + "px"');
							s.setExpression('width', '' + bsw + ' > ' + bcw + ' ? ' + bsw + ' : ' + bcw + ' + "px"');
						} else {
							var te, le;
							if (p && p.constructor === Array) {
								var top = p[0] ? typeof p[0] === 'number' ? p[0].toString() : p[0].replace(/px/, '') : el.css('top').replace(/px/, '');
								te = top.indexOf('%') === -1 ? top + ' + (t = ' + st + ' ? ' + st + ' : ' + bst + ') + "px"' : parseInt(top.replace(/%/, '')) + ' * ((' + ch + ' || ' + bch + ') / 100) + (t = ' + st + ' ? ' + st + ' : ' + bst + ') + "px"';
	
								if (p[1]) {
									var left = typeof p[1] === 'number' ? p[1].toString() : p[1].replace(/px/, '');
									le = left.indexOf('%') === -1 ? left + ' + (t = ' + sl + ' ? ' + sl + ' : ' + bsl + ') + "px"' : parseInt(left.replace(/%/, '')) + ' * ((' + cw + ' || ' + bcw + ') / 100) + (t = ' + sl + ' ? ' + sl + ' : ' + bsl + ') + "px"';
								}
							} else {
								te = '(' + ch + ' || ' + bch + ') / 2 - (this.offsetHeight / 2) + (t = ' + st + ' ? ' + st + ' : ' + bst + ') + "px"';
								le = '(' + cw + ' || ' + bcw + ') / 2 - (this.offsetWidth / 2) + (t = ' + sl + ' ? ' + sl + ' : ' + bsl + ') + "px"';
							}
							s.removeExpression('top');
							s.removeExpression('left');
							s.setExpression('top', te);
							s.setExpression('left', le);
						}
					}
				});
			},
			/*
	   * Place focus on the first or last visible input
	   */
			focus: function focus(pos) {
				var s = this,
				    p = pos && $.inArray(pos, ['first', 'last']) !== -1 ? pos : 'first';
	
				// focus on dialog or the first visible/enabled input element
				var input = $(':input:enabled:visible:' + p, s.d.wrap);
				setTimeout(function () {
					input.length > 0 ? input.focus() : s.d.wrap.focus();
				}, 10);
			},
			getDimensions: function getDimensions() {
				// fix a jQuery bug with determining the window height - use innerHeight if available
				var s = this,
				    h = typeof window.innerHeight === 'undefined' ? wndw.height() : window.innerHeight;
	
				d = [doc.height(), doc.width()];
				w = [h, wndw.width()];
			},
			getVal: function getVal(v, d) {
				return v ? typeof v === 'number' ? v : v === 'auto' ? 0 : v.indexOf('%') > 0 ? parseInt(v.replace(/%/, '')) / 100 * (d === 'h' ? w[0] : w[1]) : parseInt(v.replace(/px/, '')) : null;
			},
			/*
	   * Update the container. Set new dimensions, if provided.
	   * Focus, if enabled. Re-bind events.
	   */
			update: function update(height, width) {
				var s = this;
	
				// prevent update if dialog does not exist
				if (!s.d.data) {
					return false;
				}
	
				// reset orig values
				s.d.origHeight = s.getVal(height, 'h');
				s.d.origWidth = s.getVal(width, 'w');
	
				// hide data to prevent screen flicker
				s.d.data.hide();
				height && s.d.container.css('height', height);
				width && s.d.container.css('width', width);
				s.setContainerDimensions();
				s.d.data.show();
				s.o.focus && s.focus();
	
				// rebind events
				s.unbindEvents();
				s.bindEvents();
			},
			setContainerDimensions: function setContainerDimensions() {
				var s = this,
				    badIE = browser.ie6 || browser.ie7;
	
				// get the dimensions for the container and data
				var ch = s.d.origHeight ? s.d.origHeight : browser.opera ? s.d.container.height() : s.getVal(badIE ? s.d.container[0].currentStyle['height'] : s.d.container.css('height'), 'h'),
				    cw = s.d.origWidth ? s.d.origWidth : browser.opera ? s.d.container.width() : s.getVal(badIE ? s.d.container[0].currentStyle['width'] : s.d.container.css('width'), 'w'),
				    dh = s.d.data.outerHeight(true),
				    dw = s.d.data.outerWidth(true);
	
				s.d.origHeight = s.d.origHeight || ch;
				s.d.origWidth = s.d.origWidth || cw;
	
				// mxoh = max option height, mxow = max option width
				var mxoh = s.o.maxHeight ? s.getVal(s.o.maxHeight, 'h') : null,
				    mxow = s.o.maxWidth ? s.getVal(s.o.maxWidth, 'w') : null,
				    mh = mxoh && mxoh < w[0] ? mxoh : w[0],
				    mw = mxow && mxow < w[1] ? mxow : w[1];
	
				// moh = min option height
				var moh = s.o.minHeight ? s.getVal(s.o.minHeight, 'h') : 'auto';
				if (!ch) {
					if (!dh) {
						ch = moh;
					} else {
						if (dh > mh) {
							ch = mh;
						} else if (s.o.minHeight && moh !== 'auto' && dh < moh) {
							ch = moh;
						} else {
							ch = dh;
						}
					}
				} else {
					ch = s.o.autoResize && ch > mh ? mh : ch < moh ? moh : ch;
				}
	
				// mow = min option width
				var mow = s.o.minWidth ? s.getVal(s.o.minWidth, 'w') : 'auto';
				if (!cw) {
					if (!dw) {
						cw = mow;
					} else {
						if (dw > mw) {
							cw = mw;
						} else if (s.o.minWidth && mow !== 'auto' && dw < mow) {
							cw = mow;
						} else {
							cw = dw;
						}
					}
				} else {
					cw = s.o.autoResize && cw > mw ? mw : cw < mow ? mow : cw;
				}
	
				s.d.container.css({ height: ch, width: cw });
				s.d.wrap.css({ overflow: dh > ch || dw > cw ? 'auto' : 'visible' });
				s.o.autoPosition && s.setPosition();
			},
			setPosition: function setPosition() {
				var s = this,
				    top,
				    left,
				    hc = w[0] / 2 - s.d.container.outerHeight(true) / 2,
				    vc = w[1] / 2 - s.d.container.outerWidth(true) / 2,
				    st = s.d.container.css('position') !== 'fixed' ? wndw.scrollTop() : 0;
	
				if (s.o.position && Object.prototype.toString.call(s.o.position) === '[object Array]') {
					top = st + (s.o.position[0] || hc);
					left = s.o.position[1] || vc;
				} else {
					top = st + hc;
					left = vc;
				}
				s.d.container.css({ left: left, top: top });
			},
			watchTab: function watchTab(e) {
				var s = this;
	
				if ($(e.target).parents('.simplemodal-container').length > 0) {
					// save the list of inputs
					s.inputs = $(':input:enabled:visible:first, :input:enabled:visible:last', s.d.data[0]);
	
					// if it's the first or last tabbable element, refocus
					if (!e.shiftKey && e.target === s.inputs[s.inputs.length - 1] || e.shiftKey && e.target === s.inputs[0] || s.inputs.length === 0) {
						e.preventDefault();
						var pos = e.shiftKey ? 'last' : 'first';
						s.focus(pos);
					}
				} else {
					// might be necessary when custom onShow callback is used
					e.preventDefault();
					s.focus();
				}
			},
			/*
	   * Open the modal dialog elements
	   * - Note: If you use the onOpen callback, you must "show" the
	   *         overlay and container elements manually
	   *         (the iframe will be handled by SimpleModal)
	   */
			open: function open() {
				var s = this;
				// display the iframe
				s.d.iframe && s.d.iframe.show();
	
				if ($.isFunction(s.o.onOpen)) {
					// execute the onOpen callback
					s.o.onOpen.apply(s, [s.d]);
				} else {
					// display the remaining elements
					s.d.overlay.show();
					s.d.container.show();
					s.d.data.show();
				}
	
				s.o.focus && s.focus();
	
				// bind default events
				s.bindEvents();
			},
			/*
	   * Close the modal dialog
	   * - Note: If you use an onClose callback, you must remove the
	   *         overlay, container and iframe elements manually
	   *
	   * @param {boolean} external Indicates whether the call to this
	   *     function was internal or external. If it was external, the
	   *     onClose callback will be ignored
	   */
			close: function close() {
				var s = this;
	
				// prevent close when dialog does not exist
				if (!s.d.data) {
					return false;
				}
	
				// remove the default events
				s.unbindEvents();
	
				if ($.isFunction(s.o.onClose) && !s.occb) {
					// set the onClose callback flag
					s.occb = true;
	
					// execute the onClose callback
					s.o.onClose.apply(s, [s.d]);
				} else {
					// if the data came from the DOM, put it back
					if (s.d.placeholder) {
						var ph = $('#simplemodal-placeholder');
						// save changes to the data?
						if (s.o.persist) {
							// insert the (possibly) modified data back into the DOM
							ph.replaceWith(s.d.data.removeClass('simplemodal-data').css('display', s.display));
						} else {
							// remove the current and insert the original,
							// unmodified data back into the DOM
							s.d.data.hide().remove();
							ph.replaceWith(s.d.orig);
						}
					} else {
						// otherwise, remove it
						s.d.data.hide().remove();
					}
	
					// remove the remaining elements
					s.d.container.hide().remove();
					s.d.overlay.hide();
					s.d.iframe && s.d.iframe.hide().remove();
					s.d.overlay.remove();
	
					// reset the dialog object
					s.d = {};
				}
			}
		};
	});

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var components = __webpack_require__(9);
	var utils = __webpack_require__(3);
	var $ = __webpack_require__(4);
	var SPScript = __webpack_require__(1);
	
	SPScript.utils.waitForLibrary("SP.UI.AspMenu").then(function () {
	    SP.UI.AspMenu.$18 = function () {
	        return false;
	    };
	});
	
	exports.create = function () {
	
	    components.footer.create("#natp-footer");
	    components.header.create();
	
	    //Try to show breadcrumb on non-system pages
	    if (window._natpBreadcrumbEnabled) {
	        components.breadcrumb.create("#breadcrumbTrail");
	    }
	
	    // Add "Publish" button to Breadcrumb Termset
	    if (utils.isPage("TermStoreManager.aspx")) {
	        components.breadcrumbPublisher.create();
	    }
	    // components.loginForm.create(".natp-login-container");
	};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var modals = __webpack_require__(15);
	var utils = __webpack_require__(3);
	var googleAnalytics = __webpack_require__(16);
	
	var handlers = {
	    communityModal: function communityModal(e) {
	        e.preventDefault();
	        var url = $(this).attr("href");
	        modals.launch(url).then(function (result) {
	            return console.log(result);
	        });
	    },
	    teaserLink: function teaserLink(e) {
	        // if they aren't authenticated
	        if (!utils.isAuthenticated()) {
	            e.preventDefault();
	            var target = encodeURIComponent($(this).attr("href"));
	            var modalUrl = _spPageContextInfo.siteAbsoluteUrl + "/pages/loginmodal.aspx";
	            var intendedUrl = encodeURIComponent(modalUrl + "?loginSuccess=true");
	            var url = modalUrl + "?IntendedUrl=" + intendedUrl + "&teaserUrl=" + target;
	            modals.launch(url).then(function (result) {
	                // only redirect if we get a status of 1 from login page
	                if (result.status === 1) window.location.href = decodeURIComponent(target);
	            });
	        };
	    },
	    loginModalLink: function loginModalLink(e) {
	        e.preventDefault();
	        window.top.location.href = e.target.href;
	    },
	    accordian: function accordian(e) {
	        e.preventDefault();
	        $(this).closest('div').next('.togglebody,.togglebar-wrapper-body').slideToggle();
	
	        if ($(this).children('span').hasClass('halflings-triangle-right')) {
	            $(this).children('span').removeClass('halflings-triangle-right');
	            $(this).children('span').addClass('halflings-triangle-bottom');
	        } else {
	            $(this).children('span').removeClass('halflings-triangle-bottom');
	            $(this).children('span').addClass('halflings-triangle-right');
	        }
	
	        $(this).toggleClass('active');
	    },
	    readmore: function readmore(e) {
	        $(this).closest('div').next('.togglebody').slideToggle();
	
	        if ($(this).hasClass('closed')) {
	            $(this).text('Read Less');
	        } else {
	            $(this).text('Read More');
	        }
	
	        $(this).toggleClass('closed');
	    },
	    tgdetails: function tgdetails(e) {
	        $(this).closest('div').next('.togglebody').slideToggle();
	
	        if ($(this).hasClass('closed')) {
	            $(this).text('View fewer details -');
	        } else {
	            $(this).text('View more details +');
	        }
	
	        $(this).toggleClass('closed');
	    },
	    tgschedule: function tgschedule(e) {
	        $(this).closest('div').next('.togglebody').slideToggle();
	
	        if ($(this).hasClass('closed')) {
	            $(this).text('Hide schedule -');
	        } else {
	            $(this).text('Show schedule +');
	        }
	
	        $(this).toggleClass('closed');
	    },
	    tgscpechart: function tgscpechart(e) {
	        $(this).closest('div').next('.togglebody').slideToggle();
	
	        if ($(this).hasClass('closed')) {
	            $(this).text('Hide full CPE chart -');
	        } else {
	            $(this).text('Show full CPE chart +');
	        }
	
	        $(this).toggleClass('closed');
	    }
	};
	
	exports.bind = function () {
	    jQuery("body").on("click", ".NATP-Community-Modal", handlers.communityModal);
	    jQuery("body").on("click", ".teaser-link", handlers.teaserLink);
	    jQuery("body").on("click", ".togglebar,.togglebar-wrapper-header", handlers.accordian);
	    jQuery("body").on("click", ".readmore", handlers.readmore);
	    jQuery("body").on("click", ".tgdetails", handlers.tgdetails);
	    jQuery("body").on("click", ".tgschedule", handlers.tgschedule);
	    jQuery("body").on("click", ".tgscpechart", handlers.tgscpechart);
	    if (utils.isInIFrame()) jQuery("body").on("click", "#loginModal-container a", handlers.loginModalLink);
	    if (window._natpAnalytics) jQuery("body").on("click", "a", googleAnalytics.trackClick);
	};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var SPScript = __webpack_require__(1);
	
	if (window._natpAnalytics) {
	    // Setup Google Analytics
	    __webpack_require__(16).setup();
	    // Setup Qualaroo
	    __webpack_require__(39).setup();
	}
	
	var invoked = false;
	global.natpOnLoad = function () {
	    __webpack_require__(37).bind();
	};
	
	// invoke natpOnLoad when page is ready. Make sure the global array is there before trying to push
	window._spBodyOnLoadFunctionNames.push("natpOnLoad");
	
	var toggleRibbon = function toggleRibbon() {
	    //Render Ribbon Bar (Logged-in + AD User ONLY)
	    if (natp.utils.isWindowsUser()) {
	        $("#suiteBar").show();
	        $("#s4-ribbonrow").show();
	    }
	};
	
	var hideLeftNavLinks = function hideLeftNavLinks() {
	    //Hide "Recent" left nav group
	    $(".ms-core-listMenu-item:contains('Recent')").parent().hide();
	    //Hide "Site Contents" left nav link	
	    $(".ms-splinkbutton-text:contains('Site Contents')").parent().hide();
	};
	
	exports.domReady = function () {
	    toggleRibbon();
	    hideLeftNavLinks();
	    __webpack_require__(36).create();
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.setup = function () {
	    var _kiq = window._kiq || [];
	    (function () {
	        setTimeout(function () {
	            var d = document,
	                f = d.getElementsByTagName('script')[0],
	                s = d.createElement('script');
	            s.type = 'text/javascript';
	            s.async = true;
	            s.src = '//s3.amazonaws.com/ki.js/59820/dro.js';
	            f.parentNode.insertBefore(s, f);
	        }, 1);
	    })();
	};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".breadcrumb-item+.breadcrumb-item:before{content:\" | \"}#breadcrumbTrail{visibility:hidden}#breadcrumbTrail.ready{visibility:inherit}", ""]);
	
	// exports


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#natp-footer h4{color:#414042;font-size:18px;text-transform:capitalize}#natp-footer b,#natp-footer h4{font-family:Roboto,sans-serif;font-weight:500}#natp-footer b{font-size:15px;margin-bottom:-8px}#natp-footer a{color:#414042!important}#natp-footer a:hover{color:#23527c!important}footer{background:none!important;margin-bottom:-15px;margin-top:20px!important}#natp-footer{background-color:#d0cfd0}.facebook-footer,.insta-footer,.linkedin-footer,.twitter-footer{background-image:url(\"https://www.natptax.com/Style%20Library/_natptax/social-media-icons-website-footer-all-130.png\");display:inline-block;height:30px;margin-right:5px;overflow:hidden;width:30px}.facebook-footer{background-position-x:-33px}.linkedin-footer{background-position-x:63px}.insta-footer{background-position-x:29px}.facebook-footer:hover,.insta-footer:hover,.linkedin-footer:hover,.twitter-footer:hover{background-position-y:29px}", ""]);
	
	// exports


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#login-page-content{display:flex;justify-content:center;margin:20px 0 30px}#login-page-content .centered-items{width:300px;display:flex;flex-direction:column;align-items:stretch}.login-page-title{color:#787878;font-size:20px;margin-bottom:10px}", ""]);
	
	// exports


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".natp-teaser-container{padding:0 8px}", ""]);
	
	// exports


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#basic-modal-content{display:none}#simplemodal-overlay{background-color:#000}#simplemodal-container{color:#bbb;background-color:#333;border:4px solid #444;padding:12px;padding-top:15px!important;box-sizing:content-box}#simplemodal-container .simplemodal-data{padding:8px}#simplemodal-container code{background:#141414;border-left:3px solid #65b43d;color:#bbb;display:block;font-size:12px;margin-bottom:12px;padding:4px 6px 6px}#simplemodal-container a{color:#ddd}#simplemodal-container a.modalCloseImg{background:url(\"/style library/x.png\") no-repeat;width:25px;height:29px;display:inline;z-index:3200;position:absolute;top:0;right:-10px;cursor:pointer}#simplemodal-container h3{color:#84b8d9}", ""]);
	
	// exports


/***/ }),
/* 45 */
/***/ (function(module, exports) {

	module.exports = "<span> <div id=login-trigger class=header-trigger> <span>Login</span> </div> <div class=\"login-dropdown header-dropdown\"></div> </span>";

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"loginLink natpLoginLinks\"> <div> <a href=\"https://www2.natptax.com/eweb/DynamicPage.aspx?Site=natp&WebKey=9a7aa829-1e09-4897-816d-1f261279189e\" class=\"natpLoginLink natpJoinNowLink\"> Create Account </a> </div> <div> <a href=\"https://www2.natptax.com/EWEB/DynamicPage.aspx?WebCode=forgotpassword&Site=NATP\" class=\"natpLoginLink natpForgotPasswordLink\"> Forgot Password? </a> </div> </div> <div class=natp-login-readyText></div>";

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = "<span id=natp-myaccount class=\"\"> <div id=myaccount-greeting></div> <div id=myaccount-trigger class=header-trigger> <span><span class=my-prefix>My </span>Account</span> </div> <div class=header-dropdown> <div id=natp-login-myAccountLinks></div> </div> </span>";

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	module.exports = "<div class=natp-myaccount-linksContainer> {{#linkGroups}} <ul class=natp-myaccount-linkGroup data-groupname={{GroupName}}> {{#links}} <li class=natp-myaccount-link> <a class=myaccount-link title={{Display}} href={{URL}} target={{LinkTarget}}>{{Display}}</a> </li> {{/links}} </ul> {{/linkGroups}} </div> ";

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {(function (root) {
	
	  // Store setTimeout reference so promise-polyfill will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var setTimeoutFunc = setTimeout;
	
	  function noop() {}
	  
	  // Polyfill for Function.prototype.bind
	  function bind(fn, thisArg) {
	    return function () {
	      fn.apply(thisArg, arguments);
	    };
	  }
	
	  function Promise(fn) {
	    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
	    if (typeof fn !== 'function') throw new TypeError('not a function');
	    this._state = 0;
	    this._handled = false;
	    this._value = undefined;
	    this._deferreds = [];
	
	    doResolve(fn, this);
	  }
	
	  function handle(self, deferred) {
	    while (self._state === 3) {
	      self = self._value;
	    }
	    if (self._state === 0) {
	      self._deferreds.push(deferred);
	      return;
	    }
	    self._handled = true;
	    Promise._immediateFn(function () {
	      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	      if (cb === null) {
	        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	        return;
	      }
	      var ret;
	      try {
	        ret = cb(self._value);
	      } catch (e) {
	        reject(deferred.promise, e);
	        return;
	      }
	      resolve(deferred.promise, ret);
	    });
	  }
	
	  function resolve(self, newValue) {
	    try {
	      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
	      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	        var then = newValue.then;
	        if (newValue instanceof Promise) {
	          self._state = 3;
	          self._value = newValue;
	          finale(self);
	          return;
	        } else if (typeof then === 'function') {
	          doResolve(bind(then, newValue), self);
	          return;
	        }
	      }
	      self._state = 1;
	      self._value = newValue;
	      finale(self);
	    } catch (e) {
	      reject(self, e);
	    }
	  }
	
	  function reject(self, newValue) {
	    self._state = 2;
	    self._value = newValue;
	    finale(self);
	  }
	
	  function finale(self) {
	    if (self._state === 2 && self._deferreds.length === 0) {
	      Promise._immediateFn(function() {
	        if (!self._handled) {
	          Promise._unhandledRejectionFn(self._value);
	        }
	      });
	    }
	
	    for (var i = 0, len = self._deferreds.length; i < len; i++) {
	      handle(self, self._deferreds[i]);
	    }
	    self._deferreds = null;
	  }
	
	  function Handler(onFulfilled, onRejected, promise) {
	    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	    this.promise = promise;
	  }
	
	  /**
	   * Take a potentially misbehaving resolver function and make sure
	   * onFulfilled and onRejected are only called once.
	   *
	   * Makes no guarantees about asynchrony.
	   */
	  function doResolve(fn, self) {
	    var done = false;
	    try {
	      fn(function (value) {
	        if (done) return;
	        done = true;
	        resolve(self, value);
	      }, function (reason) {
	        if (done) return;
	        done = true;
	        reject(self, reason);
	      });
	    } catch (ex) {
	      if (done) return;
	      done = true;
	      reject(self, ex);
	    }
	  }
	
	  Promise.prototype['catch'] = function (onRejected) {
	    return this.then(null, onRejected);
	  };
	
	  Promise.prototype.then = function (onFulfilled, onRejected) {
	    var prom = new (this.constructor)(noop);
	
	    handle(this, new Handler(onFulfilled, onRejected, prom));
	    return prom;
	  };
	
	  Promise.all = function (arr) {
	    var args = Array.prototype.slice.call(arr);
	
	    return new Promise(function (resolve, reject) {
	      if (args.length === 0) return resolve([]);
	      var remaining = args.length;
	
	      function res(i, val) {
	        try {
	          if (val && (typeof val === 'object' || typeof val === 'function')) {
	            var then = val.then;
	            if (typeof then === 'function') {
	              then.call(val, function (val) {
	                res(i, val);
	              }, reject);
	              return;
	            }
	          }
	          args[i] = val;
	          if (--remaining === 0) {
	            resolve(args);
	          }
	        } catch (ex) {
	          reject(ex);
	        }
	      }
	
	      for (var i = 0; i < args.length; i++) {
	        res(i, args[i]);
	      }
	    });
	  };
	
	  Promise.resolve = function (value) {
	    if (value && typeof value === 'object' && value.constructor === Promise) {
	      return value;
	    }
	
	    return new Promise(function (resolve) {
	      resolve(value);
	    });
	  };
	
	  Promise.reject = function (value) {
	    return new Promise(function (resolve, reject) {
	      reject(value);
	    });
	  };
	
	  Promise.race = function (values) {
	    return new Promise(function (resolve, reject) {
	      for (var i = 0, len = values.length; i < len; i++) {
	        values[i].then(resolve, reject);
	      }
	    });
	  };
	
	  // Use polyfill for setImmediate for performance gains
	  Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
	    function (fn) {
	      setTimeoutFunc(fn, 0);
	    };
	
	  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	    if (typeof console !== 'undefined' && console) {
	      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
	    }
	  };
	
	  /**
	   * Set the immediate function to execute callbacks
	   * @param fn {function} Function to execute
	   * @deprecated
	   */
	  Promise._setImmediateFn = function _setImmediateFn(fn) {
	    Promise._immediateFn = fn;
	  };
	
	  /**
	   * Change the function to execute on unhandled rejection
	   * @param {function} fn Function to execute on unhandled rejection
	   * @deprecated
	   */
	  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
	    Promise._unhandledRejectionFn = fn;
	  };
	  
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = Promise;
	  } else if (!root.Promise) {
	    root.Promise = Promise;
	  }
	
	})(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70).setImmediate))

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(51);
	exports.encode = exports.stringify = __webpack_require__(52);


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(49)))

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var List = __webpack_require__(60);
	var Web = __webpack_require__(64);
	var Profiles = __webpack_require__(61);
	var Search = __webpack_require__(63);
	var utils = __webpack_require__(2);
	var CustomActions = __webpack_require__(58);
	var headerUtils = __webpack_require__(5);
	/**
	 * Abstract class. You'll never work with this directly. 
	 * @abstract
	 * @private
	 * @property {Web} web - Allows interacting with the SharePoint site you connected to
	 * @property {Search} search - Allows querying through the SP Search Service
	 * @property {Profiles} profiles - Allows interacting with the SP Profile Service
	 */
	var BaseDao = function BaseDao() {
		this.web = new Web(this);
		this.search = new Search(this);
		this.profiles = new Profiles(this);
		this.customActions = new CustomActions(this);
	};
	
	BaseDao.prototype.executeRequest = function () {
		throw "Not implemented exception";
	};
	
	/**
	 * Generic helper to make AJAX GET request
	  * @example <caption>Use generic GET method to retrieve a site's content types</caption>
	 * dao.get('/web/contentTypes').then(function(data) { console.log(data.d.results)})
	 * @param {string} relativeQueryUrl - the API url relative to "/_api"
	 * @param {Object} [extendedOptions] - AJAX options (like custom request headers)
	 * @returns {Promise} - An ES6 Promise that resolves to the an object probably in the form of data.d
	 */
	BaseDao.prototype.get = function (relativeQueryUrl, extendedOptions) {
		var options = _extends({}, {
			method: "GET"
		}, extendedOptions);
		return this.executeRequest(relativeQueryUrl, options).then(utils.parseJSON);
	};
	
	BaseDao.prototype.getRequestDigest = function () {
		return this.post('/contextinfo', {}).then(function (data) {
			return data.d.GetContextWebInformation.FormDigestValue;
		});
	};
	/**
	 * If a list name is passed, an SPScript.List object, otherwise performs a request to get all the site's lists
	 * @param {string} [listname] - If a list name is passed, method is synchronous returning an SPScript.List
	 * @returns {List|Promise} - SPScript.List object or a Promise that resolves to an Array of lists
	 * @example <caption>Option 1: No List Name gets all the lists of a site</caption>
	 * dao.lists().then(function(lists) { console.log(lists)});
	 * @example <caption>Option 2: Pass a List Name to get a list object</caption>
	 * var list = dao.lists('MyList');
	 * list.getItemById(12).then(function(item) { console.log(item)});
	 */
	BaseDao.prototype.lists = function (listname) {
		if (!listname) {
			return this.get("/web/lists").then(utils.validateODataV2);
		}
		return new List(listname, this);
	};
	
	/**
	 * Generic helper to make AJAX POST request
	 * @param {string} relativeQueryUrl - the API url relative to "/_api"
	 * @param {Object} [extendedOptions] - AJAX options (like custom request headers)
	 * @returns {Promise} - An ES6 Promise
	 */
	BaseDao.prototype.post = function (relativePostUrl, body, opts) {
		body = packagePostBody(body, opts);
		var options = {
			method: "POST",
			data: body
		};
		options = _extends({}, options, opts);
		return this.executeRequest(relativePostUrl, options).then(utils.parseJSON);
	};
	
	BaseDao.prototype.authorizedPost = function (relativePostUrl, body, verb) {
		var _this = this;
	
		return this.getRequestDigest().then(function (digest) {
			return headerUtils.getActionHeaders(verb, digest);
		}).then(function (headers) {
			return _this.post(relativePostUrl, body, { headers: headers });
		});
	};
	
	BaseDao.prototype.ensureRequestDigest = function (digest) {
		return digest ? Promise.resolve(digest) : this.getRequestDigest();
	};
	
	//Skip stringify it its already a string or it has an explicit Content-Type that is not JSON
	var packagePostBody = function packagePostBody(body, opts) {
		// if its already a string just return
		if (typeof body === "string") return body;
		// if it has an explicit content-type, asssume the body is already that type
		if (opts && opts.headers && opts.headers["Content-Type"] && opts.headers["Content-Type"].indexOf("json") === -1) {
			return body;
		}
		//others stringify
		return JSON.stringify(body);
	};
	module.exports = BaseDao;
	//# sourceMappingURL=baseDao.js.map

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var templating = __webpack_require__(19);
	
	function createTemplateRenderer(htmlTemplate, events) {
	    return function (ctx) {
	        return templating.render(htmlTemplate, ctx);
	    };
	}
	
	function createFormFieldRenderer(field) {
	    return function (ctx) {
	        var formCtx = ctx.FormContext;
	        if (field.onReady) {
	            if (formCtx) {
	                formCtx.registerInitCallback(field.name, field.onReady.bind(null, ctx));
	            } else {
	                setTimeout(field.onReady.bind(null, ctx), 100);
	            }
	        }
	        if (field.getValue && formCtx) {
	            formCtx.registerGetValueCallback(field.name, field.getValue.bind(null, ctx));
	        }
	        // tack on 'setValue' function
	        if (formCtx && formCtx.updateControlValue) {
	            field.setValue = function (value) {
	                formCtx.updateControlValue(field.name, value);
	            };
	        }
	
	        return field.render(ctx);
	    };
	}
	
	function createDisplayFieldRenderer(field) {
	    return function (ctx) {
	        var formCtx = ctx.FormContext;
	        if (formCtx && formCtx.registerInitCallback && field.onReady) {
	            formCtx.registerInitCallback(field.name, field.onReady);
	        }
	        return field.render(ctx);
	    };
	}
	
	var renderers = {
	    template: {
	        create: createTemplateRenderer
	    },
	    formField: {
	        create: createFormFieldRenderer
	    },
	    displayField: {
	        create: createDisplayFieldRenderer
	    }
	};
	
	module.exports = renderers;
	//# sourceMappingURL=csr-renderers.js.map

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var renderers = exports.renderers = __webpack_require__(56);
	
	//fieldComponent = { name, onReady, render, getValue, locations:["View", "NewForm","DisplayForm", "EditForm"] }
	// var renderColoredStatus = function(ctx) {
	//     // map statuses  to colors
	//     var colors = {
	//         "Not Started": "orange",
	//         "In Progress": "yellow",
	//         "Done": "green"
	//     };
	
	//     // Look at the item's status to get the mapped color
	//     // If the item has a status value that is not mapped, then use 'red'
	//     var color = colors[ctx.CurrentItem.Status] || "red";
	
	//     // return the html used to render the status field;
	//     return "<h4 style='color:" + color + "'>" + ctx.CurrentItem.Status + "</h4>";
	// };
	
	// var fieldOverride = {
	//     name:  "Status",
	//     render: renderColoredStatus
	// };
	
	// SPScript.CSR.registerDisplayField(fieldOverride);
	
	var registerFormField = exports.registerFormField = function (fieldComponent, opts) {
	    var renderer = renderers.formField.create(fieldComponent);
	    fieldComponent.locations = fieldComponent.locations || ["NewForm", "EditForm"];
	    return registerField(fieldComponent, renderer, opts);
	};
	
	//{name, onReady, render, locations: ["View", "DisplayForm"]}
	var registerDisplayField = exports.registerDisplayField = function (fieldComponent, opts) {
	    var renderer = renderers.displayField.create(fieldComponent);
	    fieldComponent.locations = fieldComponent.locations || ["View", "DisplayForm"];
	    return registerField(fieldComponent, renderer, opts);
	};
	
	var registerField = exports.registerField = function (field, renderer, opts) {
	    var renderers = {};
	    //View, DisplayForm, EditForm, NewForm
	    field.locations.forEach(function (l) {
	        return renderers[l] = renderer;
	    });
	    var defaults = {
	        Templates: {
	            Fields: {}
	        }
	    };
	    var templateOverride = _extends({}, defaults, opts);
	    templateOverride.Templates.Fields[field.name] = renderers;
	    SPClientTemplates.TemplateManager.RegisterTemplateOverrides(templateOverride);
	    return field;
	};
	
	var registerView = exports.registerView = function (templates, options) {
	    // templates keys are Header, Item, Footer
	    //RenderFieldTemplateDefault(ctx); default renderer?
	    var defaults = {
	        //BaseViewID
	        //ListTemplateType
	        Templates: {
	            Header: function Header() {
	                return "";
	            },
	            Footer: function Footer() {
	                return "";
	            }
	        }
	    };
	
	    var templateOverride = _extends({}, defaults, options);
	    templateOverride.Templates = _extends({}, templateOverride.Templates, templates);
	
	    SPClientTemplates.TemplateManager.RegisterTemplateOverrides(templateOverride);
	};
	//# sourceMappingURL=csr.js.map

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var utils = __webpack_require__(2);
	var headers = __webpack_require__(5);
	
	var metadata = {
		__metadata: {
			"type": "SP.UserCustomAction"
		}
	};
	
	var CustomActions = function CustomActions(dao) {
		var _this = this;
	
		this._dao = dao;
	
		this.scopes = {
			"Web": {
				id: 3,
				name: "Web",
				url: "/web/usercustomactions"
			},
			"Site": {
				id: 2,
				name: "Site",
				url: "/site/usercustomactions"
			}
		};
		this.scopes.getById = function (id) {
			return id === 2 ? _this.scopes.Site : _this.scopes.Web;
		};
	};
	
	//
	// If a name is passed, filter the result set
	CustomActions.prototype.get = function (name) {
		var _this2 = this;
	
		// first get the site scoped ones, then the web scoped ones
		return this._dao.get(this.scopes.Site.url).then(utils.validateODataV2).then(function (siteCustomActions) {
			return _this2._dao.get(_this2.scopes.Web.url).then(utils.validateODataV2)
			//combine site scoped and web scoped into single array
			.then(function (webCustomActions) {
				return siteCustomActions.concat(webCustomActions);
			});
		}).then(function (customActions) {
			// if a name was passed filter it otherwise return everything
			if (name) {
				var matches = customActions.filter(function (a) {
					return a.Name === name;
				});
				if (matches.length) {
					return matches[0];
				}
				throw new Error("Unable to find Custom Action with name: " + name);
			} else return customActions;
		});
	};
	
	CustomActions.prototype._getUrl = function (name) {
		var _this3 = this;
	
		return this.get(name).then(function (a) {
			return _this3.scopes.getById(a.Scope).url + "('" + a.Id + "')";
		});
	};
	
	CustomActions.prototype._getUrlAndDigest = function (name) {
		var _this4 = this;
	
		var prep = {};
		return this._getUrl(name).then(function (url) {
			prep.url = url;
			return _this4._dao.getRequestDigest();
		}).then(function (digest) {
			prep.digest = digest;
			return prep;
		});
	};
	
	CustomActions.prototype.update = function (updates) {
		var _this5 = this;
	
		if (!updates || !updates.Name) throw new Error("You must at least pass a Custom Action 'Name'");
	
		return this._getUrlAndDigest(updates.Name).then(function (prep) {
			updates = _extends({}, metadata, updates);
			var opts = {
				headers: headers.getUpdateHeaders(prep.digest)
			};
			return _this5._dao.post(prep.url, updates, opts);
		});
	};
	
	CustomActions.prototype.remove = function (name) {
		var _this6 = this;
	
		if (!name) throw new Error("You must at least pass a Custom Action 'Name'");
		return this._getUrlAndDigest(name).then(function (prep) {
			var opts = {
				headers: headers.getDeleteHeaders(prep.digest)
			};
			return _this6._dao.post(prep.url, {}, opts);
		});
	};
	
	CustomActions.prototype.add = function (customAction) {
		var _this7 = this;
	
		if (!customAction || !customAction.Name || !customAction.Location) throw new Error("You must at least pass a Custom Action 'Name' and 'Location'");
		customAction.Scope = customAction.Scope || "Web";
		return this._dao.getRequestDigest().then(function (digest) {
			customAction = _extends({}, metadata, customAction);
			var scope = _this7.scopes[customAction.Scope];
			customAction.Scope = scope.id;
			var opts = {
				headers: headers.getAddHeaders(digest)
			};
			return _this7._dao.post(scope.url, customAction, opts);
		});
	};
	
	CustomActions.prototype.addScriptLink = function (name, url, opts) {
		var customAction = {
			Name: name,
			Title: name,
			Description: name,
			Group: name,
			Sequence: 100,
			Scope: "Web",
			Location: "ScriptLink",
			ScriptSrc: url
		};
		customAction = _extends({}, customAction, opts || {});
	
		return this.add(customAction);
	};
	
	CustomActions.prototype.addCSSLink = function (name, url, opts) {
		var scriptBlockStr = "\n\t\t(function() {\n\t\t\tvar head = document.querySelector(\"head\");\n\t\t\tvar styleTag = document.createElement(\"style\");\n\t\t\tstyleTag.appendChild(document.createTextNode(\"body { opacity: 0 }\"));\n\t\t\t\n\t\t\tvar linkTag = document.createElement(\"link\");\n\t\t\tlinkTag.rel = \"stylesheet\";\tlinkTag.href = \"" + url + "\"; linkTag.type = \"text/css\";\n\t\t\tlinkTag.addEventListener(\"load\", function() {\n\t\t\t\thead.removeChild(styleTag);\n\t\t\t});\n\n\t\t\thead.appendChild(styleTag);\n\t\t\thead.appendChild(linkTag);\n\t\t})();";
	
		var customAction = {
			Name: name,
			Title: name,
			Description: name,
			Group: name,
			Sequence: 100,
			Scope: "Web",
			Location: "ScriptLink",
			ScriptBlock: scriptBlockStr
		};
		customAction = _extends({}, customAction, opts || {});
	
		return this.add(customAction);
	};
	CustomActions.metadata = metadata;
	
	module.exports = CustomActions;
	//# sourceMappingURL=customActions.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(2);
	
	/**
	 * Represents a SharePoint Folder.  Keep in mind, and File or Folder objects obtained from the 'files' and 'folders' array will not have their child items populated.
	 * @typedef Folder
	 * @property {string} name - Folder name
	 * @property {string} serverRelativeUrl - Server relative url
	 * @property {int} itemCount - Number of items in the folder
	 * @property {string} guid - Unique ID of the folder
	 * @property {string} uri - API url to get the raw SP.Folder object
	 * @property {Array<File>} files - An array of files in that folder
	 * @property {Array<Folder>} folders - An array of sub folders
	 * @example
	 *  dao.web.getFolder("/sites/mysite/Shared Documents")
	 *			.then(function(folder) { 
	 *				console.log(folder.name);
	 *				console.log(folder.files);
	 *			});
	 */
	var Folder = function Folder(spFolder) {
	  this.mapProperties(spFolder);
	  this.populateChildren(spFolder);
	};
	
	Folder.prototype.populateChildren = function (spFolder) {
	  if (spFolder && spFolder.Folders && spFolder.Folders.results) {
	    this.folders = spFolder.Folders.results.map(function (f) {
	      return new Folder(f);
	    });
	  }
	  if (spFolder && spFolder.Files && spFolder.Files.results) {
	    this.files = spFolder.Files.results.map(function (f) {
	      return new File(f);
	    });
	  }
	};
	
	Folder.prototype.mapProperties = function (spFolder) {
	  this.name = spFolder.Name;
	  this.serverRelativeUrl = spFolder.ServerRelativeUrl;
	  this.itemCount = spFolder.ItemCount;
	  this.guid = spFolder.UniqueId;
	  this.uri = spFolder.__metadata.uri;
	};
	
	/**
	 * Represents a SharePoint File
	 * @typedef File
	 * @property {string} name - Folder name
	 * @property {string} title - Folder title
	 * @property {string} serverRelativeUrl - Server relative url
	 * @property {int} byteLength - File size in bytes
	 * @property {string} checkoutType - Checked out status of file.  "none", "offline", "online".
	 * @property {number} majorVersion - Major version of the file
	 * @property {number} minorVersion - Minor version of the file
	 * @property {string} uri - API url to get the raw SP.Folder object
	 * @example
	 *  dao.web.getFile("/sites/mysite/Shared Documents/myFile.docx")
	 *			.then(function(file) { 
	 *				console.log(file.name);
	 *				console.log("Size:" + (file.byteLength / 1000) + "KB");
	 *			});
	 */
	var File = function File(spFile) {
	  this.mapProperties(spFile);
	};
	
	File.prototype.mapProperties = function (spFile) {
	  this.name = spFile.Name, this.title = spFile.Title, this.checkoutType = spFile.CheckOutType, this.byteLength = spFile.Length, this.majorVersion = spFile.MajorVersion, this.minorVersion = spFile.MinorVersion, this.serverRelativeUrl = spFile.ServerRelativeUrl, this.uri = spFile.__metadata.uri;
	};
	
	module.exports = {
	  File: File,
	  Folder: Folder
	};
	//# sourceMappingURL=filesystem.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var utils = __webpack_require__(2);
	var Permissions = __webpack_require__(21);
	var headers = __webpack_require__(5);
	
	/**
	 * Represents a SharePoint list. You shouldn't ever be new'ing this class up up yourself, instead you'll get it from your dao as shown in first example.
	 * @class
	 * @param {IBaseDao} dao - Data access object used to make requests.
	 * @property {Permissions} permissions - allows checking security information of the Web
	 * @property {string} baseUrl - API relative url (value = "/web")
	 * @example <caption>You access a 'List' by passing a name to the 'lists' property of the dao.</caption>
	 * var dao = new SPScript.RestDao(_spPageContextInfo.webAbsoluteUrl);
	 * var list = dao.lists("Tasks");
	 * list.getItemById(12).then(function(item) { console.log(item) });
	 */
	var List = function List(listname, dao) {
		this.listname = listname;
		this.baseUrl = "/web/lists/getbytitle('" + listname + "')";
		this._dao = dao;
		this.permissions = new Permissions(this.baseUrl, this._dao);
	};
	
	List.prototype.getFields = function (odataQuery) {
		var url = this.baseUrl + "/fields" + appendOData(odataQuery);
		return this._dao.get(url).then(utils.validateODataV2);
	};
	
	List.prototype.getField = function (fieldName) {
		return this.getFields("$filter=InternalName eq '" + fieldName + "'").then(function (fields) {
			if (fields.length) return fields[0];else throw new Error("Unable to find field: " + fieldName);
		});
	};
	
	List.prototype.updateField = function (fieldName, updates) {
		var _this = this;
	
		this.getField(fieldName).then(function (f) {
			var url = _this.baseUrl + "/Fields(guid'" + f.Id + "')";
			updates.__metadata = { type: "SP.Field" };
			return _this._dao.authorizedPost(url, updates, "MERGE");
		});
	};
	/**
	 * Retrieves items in the lists
	 * @param {string} [odata] - OData string
	 * @returns {Promise<Array>} - A Promise that resolves an array of list items
	 * @example <caption>Get all items</caption>
	 * list.getItems().then(function(items) { console.log(items) });
	 * @example <caption>Get first 5 items by passing in optional OData.</caption>
	 * list.getItems("$top=5").then(function(items) { console.log(items) });
	 */
	List.prototype.getItems = function (odataQuery) {
		return this._dao.get(this.baseUrl + "/items" + appendOData(odataQuery)).then(utils.validateODataV2);
	};
	
	/**
	 * Retrieves a specific item based on SharePoint ID
	 * @param {int} id - SharePoint integer Id
	 * @param {string} [odata] - OData string
	 * @returns {Promise} - A Promise that resolves to a single list item
	 * @example <caption>Get the item with ID of 5.</caption>
	 * list.getItemById(5).then(function(item) { console.log(item) });
	 * @example <caption>Only bring back 'Title' and 'Status' using optional OData string</caption>
	 * list.getItemById(5, "$select=Title,Status").then(function(items) { console.log(items) });
	 */
	List.prototype.getItemById = function (id, odata) {
		var url = this.baseUrl + "/items(" + id + ")" + appendOData(odata);
		return this._dao.get(url).then(utils.validateODataV2);
	};
	
	/**
	 * Retrieves basic information about the list
	 * @returns {Promise<SP.Web>} - A Promise that resolves to an object containing non-deferred properties of an SP.List (https://msdn.microsoft.com/en-us/library/office/jj244873.aspx)
	 * @example
	 * list.info().then(function(info) { console.log(info) });
	 */
	List.prototype.info = function () {
		return this._dao.get(this.baseUrl).then(utils.validateODataV2);
	};
	
	/**
	 * Creates a SharePoint list item
	 * @param {object} item - Javascript object representing the list item
	 * @param {string} [requestDigest] - Optional request digest token used to authorize the action. One will be automatically retrieved if not provided.
	 * @returns {Promise} - A Promise that resolves to the inserted list item
	 * @example <caption>Add a list item. Set Title and Status.</caption>
	 * var newItem = {
	 *    Title: "Test Created Item",
	 *    MyStatus: "Red"
	 * };
	 * list.addItem(newItem).then(function(item) { console.log(item) });
	 */
	
	List.prototype.addItem = function (item, digest) {
		var _this2 = this;
	
		return this._dao.ensureRequestDigest(digest).then(function (digest) {
			return _this2._dao.get(_this2.baseUrl).then(function (data) {
	
				//decorate the item with the 'type' metadata
				item = _extends({}, {
					"__metadata": {
						"type": data.d.ListItemEntityTypeFullName
					}
				}, item);
	
				var customOptions = {
					headers: headers.getAddHeaders(digest)
				};
				return _this2._dao.post(_this2.baseUrl + "/items", item, customOptions);
			}).then(utils.validateODataV2);
		});
	};
	
	/**
	 * Updates a SharePoint list item
	 * @param {int} itemId - The SharePoint Id of the item to update
	 * @param {object} updates - Javascript object representing columns you want to update
	 * @param {string} [requestDigest] - Optional request digest token used to authorize the action. One will be automatically retrieved if not provided.
	 * @returns {Promise} - A Promise
	 * @example <caption>Update the item's Title</caption>
	 * var updates = {
	 *    Title: "Updated Title"
	 * };
	 * list.updateItem(12, updates).then(function() { console.log"Success") });
	 */
	List.prototype.updateItem = function (itemId, updates, digest) {
		var _this3 = this;
	
		return this._dao.ensureRequestDigest(digest).then(function (digest) {
			return _this3.getItemById(itemId).then(function (item) {
				//decorate the item with the 'type' metadata
				updates = _extends({}, {
					"__metadata": {
						"type": item.__metadata.type
					}
				}, updates);
	
				var customOptions = {
					headers: headers.getUpdateHeaders(digest, item.__metadata.etag)
				};
	
				return _this3._dao.post(item.__metadata.uri, updates, customOptions);
			});
		});
	};
	
	/**
	 * Updates a SharePoint list item
	 * @param {int} itemId - The SharePoint Id of the item to update
	 * @param {string} [requestDigest] - Optional request digest token used to authorize the action. One will be automatically retrieved if not provided.
	 * @returns {Promise} - A Promise
	 * @example <caption>Delete the item with an ID of 12</caption>
	 * list.deleteItem(12).then(function() { console.log"Success") });
	 */
	List.prototype.deleteItem = function (itemId, digest) {
		var _this4 = this;
	
		return this._dao.ensureRequestDigest(digest).then(function (digest) {
			return _this4.getItemById(itemId).then(function (item) {
				var customOptions = {
					headers: headers.getDeleteHeaders(digest, item.__metadata.etag)
				};
				return _this4._dao.post(item.__metadata.uri, "", customOptions);
			});
		});
	};
	
	/**
	 * Attach file to an item in the list
	 * @param {int} itemId - The SharePoint Id of the item to update
	 * @param {string} filename - Filename to be put in SharePoint
	 * @param {string} content - File content
	 * @returns {Promise} - A Promise
	 * @example <caption>Attach 'hello.txt' with content 'Hello World' to itemId 12</caption>
	 * list.addAttachment(12, 'hello.txt', 'Hello World').then(function() { console.log"Success") });
	 */
	List.prototype.addAttachment = function (itemId, filename, content, requestDigest) {
		var _this5 = this;
	
		if (requestDigest) return this._addAttachment(itemId, filename, content, requestDigest);
		return this._dao.getRequestDigest().then(function (requestDigest) {
			return _this5._addAttachment(itemId, filename, content, requestDigest);
		});
	};
	
	List.prototype._addAttachment = function (itemId, filename, content, requestDigest) {
		var customOptions = {
			headers: headers.getFilestreamHeaders(requestDigest),
			data: content
		};
		return this._dao.post(this.baseUrl + "/items(" + itemId + ")/AttachmentFiles/add(FileName='" + filename + "')", null, customOptions);
	};
	
	/**
	 * Delete attachment of an item in the list
	 * @param {int} itemId - The SharePoint Id of the item to update
	 * @param {string} filename - Filename to be deleted in SharePoint
	 * @returns {Promise} - A Promise
	 * @example <caption>Delete attachment 'hello.txt' in itemId 12</caption>
	 * list.deleteAttachment(12, 'hello.txt').then(function() { console.log"Success") });
	 */
	List.prototype.deleteAttachment = function (itemId, filename, requestDigest) {
		var _this6 = this;
	
		if (requestDigest) return this._deleteAttachment(itemId, filename, requestDigest);
		return this._dao.getRequestDigest().then(function (requestDigest) {
			return _this6._deleteAttachment(itemId, filename, requestDigest);
		});
	};
	List.prototype._deleteAttachment = function (itemId, filename, requestDigest) {
		var _this7 = this;
	
		return this._dao.get(this.baseUrl).then(function (data) {
			var customOptions = {
				headers: {
					'Accept': 'application/json;odata=verbose',
					'X-RequestDigest': requestDigest,
					'X-HTTP-Method': "DELETE"
				}
			};
			return _this7._dao.post(_this7.baseUrl + "/items(" + itemId + ")/AttachmentFiles('" + filename + "')", null, customOptions);
		});
	};
	
	/**
	 * Retrieves items in the list based on the value of a column
	 * @param {string} key - The column name
	 * @param {string} value - The column value to match on
	 * @param {string} [odata] - OData string
	 * @returns {Promise<Array>} - A Promise that resolves an array of list items
	 * @example <caption>Get all items whose status is "In Progress"</caption>
	 * list.findItems("Status", "In Progress").then(function(items) { console.log(items) });
	 * @example <caption>Get first 5 items whose Yes/No field is 'Yes'</caption>
	 * list.getItems("MyYesNoField", true, "$top=5").then(function(items) { console.log(items) });
	 */
	List.prototype.findItems = function (key, value, extraOData) {
		//if its a string, wrap in single quotes
		var filterValue = typeof value === "string" ? "'" + value + "'" : value;
		var odata = "$filter=" + key + " eq " + filterValue + appendOData(extraOData, "&");
	
		return this.getItems(odata);
	};
	
	/**
	 * Retrieves the first list item that matches the column value you pass
	 * @param {string} key - The column name
	 * @param {string} value - The column value to match on
	 * @param {string} [odata] - OData string
	 * @returns {Promise} - A Promise that resolves to a list items
	 * @example <caption>The first item whose Title is "TODO"</caption>
	 * list.findItem("Title", "TODO").then(function(item) { console.log(item) });
	 */
	List.prototype.findItem = function (key, value, odata) {
		return this.findItems(key, value, odata).then(function (items) {
			if (items && items.length && items.length > 0) {
				return items[0];
			}
			return null;
		});
	};
	
	var appendOData = function appendOData(odata, prefix) {
		prefix = prefix || "?";
		if (odata) return prefix + odata;
		return "";
	};
	
	module.exports = List;
	//# sourceMappingURL=list.js.map

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(2);
	var headers = __webpack_require__(5);
	
	/**
	 * Allows you to perform queries agains the SP Profile Service. You shouldn't ever be new'ing this class up up yourself, instead you'll get it from your dao as shown in first example.
	 * @class
	 * @param {IBaseDao} dao - Data access object used to make requests.
	 * @example <caption>You access this Profiles class using the 'profiles' property of the dao</caption>
	 * var dao = new SPScript.RestDao(_spPageContextInfo.webAbsoluteUrl);
	 * dao.profiles.current().then(function(profile) { console.log(profile) });
	 */
	var Profiles = function Profiles(dao) {
		this._dao = dao;
		this.baseUrl = "/SP.UserProfiles.PeopleManager";
	};
	
	var transformPersonProperties = function transformPersonProperties(profile) {
		profile.UserProfileProperties.results.forEach(function (keyvalue) {
			profile[keyvalue.Key] = keyvalue.Value;
		});
		return profile;
	};
	
	/**
	 * Gets the profile of the current user
	 * @returns {Promise} - A Promise that resolves an object containing all the profile properties
	 * @example
	 * dao.profiles.current().then(function(profile) { console.log(profile.PreferredName) });
	 */
	Profiles.prototype.current = function () {
		var url = this.baseUrl + "/GetMyProperties";
		return this._dao.get(url).then(utils.validateODataV2).then(transformPersonProperties);
	};
	
	/**
	 * Sets a profile property
	 * @param {User|string} userOrEmail - Pass in a User object (must have 'AccountName' or 'LoginName') or an email address
	 * @returns {Promise} - A Promise
	 * @example
	 * var email = "andrew@andrewpetersen.onmicrosoft.com";
	 * var aboutMe = "I am a web developer";
	 * dao.profiles.setProperty(email, "AboutMe", aboutMe).then(function() { console.log("Success") });
	 */
	// Supports email string or a user object
	Profiles.prototype.setProperty = function (userOrEmail, key, value, digest) {
		var _this = this;
	
		return this._dao.ensureRequestDigest(digest).then(function (digest) {
			var url = _this.baseUrl + "/SetSingleValueProfileProperty";
			var args = {
				propertyName: key,
				propertyValue: value
			};
	
			var customOptions = {
				headers: headers.getStandardHeaders(digest)
			};
	
			// if a string is passed, assume its an email address, otherwise a user was passed
			if (typeof userOrEmail === "string") {
				return _this.getByEmail(userOrEmail).then(function (user) {
					args.accountName = user.AccountName;
					return _this._dao.post(url, args, customOptions);
				});
			} else {
				args.accountName = userOrEmail.LoginName || userOrEmail.AccountName;
				return _this._dao.post(url, args, customOptions);
			}
		});
	};
	
	Profiles.prototype.getProfile = function (user) {
		var login = encodeURIComponent(user.LoginName);
		var url = this.baseUrl + "/GetPropertiesFor(accountName=@v)?@v='" + login + "'";
		return this._dao.get(url).then(utils.validateODataV2).then(transformPersonProperties);
	};
	
	/**
	 * Gets the profile of the user tied to the specified email
	 * @returns {Promise} - A Promise that resolves an object containing all the profile properties
	 * @example
	 * var email = "andrew@andrewpetersen.onmicrosoft.com";
	 * dao.profiles.getByEmail(email)
	 *    .then(function(profile) { console.log(profile.PreferredName) });
	 */
	Profiles.prototype.getByEmail = function (email) {
		var _this2 = this;
	
		return this._dao.web.getUser(email).then(function (user) {
			return _this2.getProfile(user);
		});
	};
	
	module.exports = Profiles;
	//# sourceMappingURL=profiles.js.map

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var BaseDao = __webpack_require__(55);
	var ajax = __webpack_require__(20);
	var utils = __webpack_require__(2);
	/**
	 * Main point of entry. Big Daddy class that all SP requests are routed through. Data Access Object (DAO)
	 * @class
	 * @augments BaseDao
	
	 * @param {string} [url] - Url of the site you are connected to. _spPageContextInfo.webAbsoluteUrl will be used if no value is passed.
	 * @property {string} webUrl - Url of the site you are connected to
	 * @property {Web} web - Allows interacting with the SharePoint site you connected to
	 * @property {Search} search - Allows querying through the SP Search Service
	 * @property {Profiles} profiles - Allows interacting with the SP Profile Service
	 * @example <caption>Create a new instance of a RestDao</caption>
	 * var dao = new SPScript.RestDao(_spPageContextInfo.webAbsoluteUrl);
	 */
	var RestDao = function RestDao(url) {
		var self = this;
		BaseDao.call(this);
		this.webUrl = url || _spPageContextInfo.webAbsoluteUrl;
	};
	
	RestDao.prototype = Object.create(BaseDao.prototype);
	
	RestDao.prototype.executeRequest = function (url, options) {
		var fullUrl = /^http/i.test(url) ? url : this.webUrl + "/_api" + url;
	
		var defaultOptions = {
			url: fullUrl,
			method: "GET",
			headers: {
				"Accept": "application/json; odata=verbose",
				"Content-Type": "application/json; odata=verbose"
			}
		};
	
		var ajaxOptions = _extends({}, defaultOptions, options);
		return ajax(ajaxOptions).catch(utils.handleErrorResponse);
	};
	
	module.exports = RestDao;
	//# sourceMappingURL=restDao.js.map

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var queryString = __webpack_require__(22);
	var utils = __webpack_require__(2);
	
	/**
	 * Allows you to perform queries agains the SP Search Service. You shouldn't ever be new'ing this class up up yourself, instead you'll get it from your dao as shown in first example.
	 * @class
	 * @param {IBaseDao} dao - Data access object used to make requests.
	 * @example <caption>You access this Search class using the 'search' property of the dao</caption>
	 * var dao = new SPScript.RestDao(_spPageContextInfo.webAbsoluteUrl);
	 * dao.search.query('andrew').then(function(result) { console.log(result.items) });
	 */
	var Search = function Search(dao) {
	  this._dao = dao;
	};
	
	/**
	 * Represents the response sent back from the Search Service after a query
	 * @typedef {Object} QueryOptions
	 * @property {string} sourceid - Special id that allows filter of types
	 * @property {int} startrow - 
	 * @property {int} rowlimit - How many items to bring back
	 * @property {Array<string>} selectedproperties - An array of the property names to bring back
	 * @property {Array<string>} refiners - An array of the refiners to bring back
	 * @property {?} hiddenconstraints - 
	 * @property {?} sortlist - 
	 */
	Search.QueryOptions = function () {
	  this.sourceid = null;
	  this.startrow = null;
	  this.rowlimit = 30;
	  this.selectedproperties = null;
	  this.refiners = null;
	  this.refinementfilters = null;
	  this.hiddenconstraints = null;
	  this.sortlist = null;
	};
	
	var convertRowsToObjects = function convertRowsToObjects(itemRows) {
	  var items = [];
	
	  for (var i = 0; i < itemRows.length; i++) {
	    var row = itemRows[i],
	        item = {};
	    for (var j = 0; j < row.Cells.results.length; j++) {
	      item[row.Cells.results[j].Key] = row.Cells.results[j].Value;
	    }
	
	    items.push(item);
	  }
	
	  return items;
	};
	
	/**
	 * Represents the response sent back from the Search Service after a query
	 * @typedef {Object} SearchResults
	 * @property {string} elapsedTime - How long the query took
	 * @property {object} suggestion - Spelling suggestion
	 * @property {int} resultsCount - Number of results in this batch
	 * @property {int} totalResults - Total number of results that could be returned
	 * @property {int} totalResultsIncludingDuplicates - Total number of results that could be returned including duplicates
	 * @property {Array} items - An array of search result items.  Properties will depend of the item type.
	 * @property {?Array<Refiner>} refiners - An array of refiners. Can be null.
	 */
	var SearchResults = function SearchResults(queryResponse) {
	  this.elapsedTime = queryResponse.ElapsedTime;
	  this.suggestion = queryResponse.SpellingSuggestion;
	  this.resultsCount = queryResponse.PrimaryQueryResult.RelevantResults.RowCount;
	  this.totalResults = queryResponse.PrimaryQueryResult.RelevantResults.TotalRows;
	  this.totalResultsIncludingDuplicates = queryResponse.PrimaryQueryResult.RelevantResults.TotalRowsIncludingDuplicates;
	  this.items = convertRowsToObjects(queryResponse.PrimaryQueryResult.RelevantResults.Table.Rows.results);
	  this.refiners = mapRefiners(queryResponse.PrimaryQueryResult.RefinementResults);
	};
	
	/**
	 * Represents the response sent back from the Search Service after a query
	 * @typedef {Object} Refiner
	 * @property {string} RefinerName - How long the query took
	 * @property {Array} RefinerOptions - An array of valid refiner values
	 */
	
	var mapRefiners = function mapRefiners(refinementResults) {
	  var refiners = [];
	
	  if (refinementResults && refinementResults.Refiners && refinementResults.Refiners.results) {
	    refiners = refinementResults.Refiners.results.map(function (r) {
	      return {
	        RefinerName: r.Name,
	        RefinerOptions: r.Entries.results
	      };
	    });
	  }
	  return refiners;
	};
	
	/**
	 * Performs a query using the search service
	 * @param {string} queryText - The query text to send to the Search Service
	 * @param {QueryOptions} [[queryOptions]] - Override the default query options
	 * @returns {Promise<SearchResults>} - A Promise that resolves to a SearchResults object
	 * @example
	 * dao.search.query('audit').then(function(result) { console.log(result.items) });
	 */
	Search.prototype.query = function (queryText, queryOptions) {
	  var optionsQueryString = queryOptions != null ? "&" + queryString.fromObj(queryOptions, true) : "";
	
	  var url = "/search/query?querytext='" + queryText + "'" + optionsQueryString;
	  return this._dao.get(url).then(utils.validateODataV2).then(function (resp) {
	    if (resp.query) {
	      return new SearchResults(resp.query);
	    }
	    throw new Error("Invalid response back from search service");
	  });
	};
	
	/**
	 * Performs a query using the search service
	 * @param {string} queryText - The query text to send to the Search Service
	 * @param {QueryOptions} [[queryOptions]] - Override the default query options
	 * @returns {Promise<SearchResults>} - A Promise that resolves to a SearchResults object
	 * @example
	 * dao.search.people('andrew').then(function(result) { console.log(result.items) });
	 */
	Search.prototype.people = function (queryText, queryOptions) {
	  var options = queryOptions || {};
	  options.sourceid = 'b09a7990-05ea-4af9-81ef-edfab16c4e31';
	  return this.query(queryText, options);
	};
	
	/**
	 * Performs a query for just sites using the search service
	 * @param {string} queryText - The query text to send to the Search Service
	 * @param {string} [[scope]] - A url to scope the results to
	 * @param {QueryOptions} [[queryOptions]] - Override the default query options
	 * @returns {Promise<SearchResults>} - A Promise that resolves to a SearchResults object
	 * @example
	 * dao.search.sites('andrew').then(function(result) { console.log(result.items) });
	 */
	Search.prototype.sites = function (queryText, scope) {
	  var queryOptions = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	  queryText = queryText || "";
	  scope = scope ? 'Path:' + scope + '*' : "";
	  var query = (queryText + ' contentclass:STS_Web ' + scope).trim();
	  queryOptions.rowlimit = queryOptions.rowlimit || 499;
	  return this.query(query, queryOptions);
	};
	
	module.exports = Search;
	//# sourceMappingURL=search.js.map

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var utils = __webpack_require__(2);
	var Permissions = __webpack_require__(21);
	var headers = __webpack_require__(5);
	var Folder = __webpack_require__(59).Folder;
	/**
	 * Represents a SharePoint site. You shouldn't ever be new'ing this class up up yourself, instead you'll get it from your dao as shown in first example.
	 * @class
	 * @param {IBaseDao} dao - Data access object used to make requests.
	 * @property {Permissions} permissions - allows checking security information of the Web
	 * @property {string} baseUrl - API relative url (value = "/web")
	 * @example <caption>You access this Web class using the 'web' property of the dao</caption>
	 * var dao = new SPScript.RestDao(_spPageContextInfo.webAbsoluteUrl);
	 * dao.web.info().then(function(info) { console.log(info) });
	 */
	var Web = function Web(dao) {
		this._dao = dao;
		this.baseUrl = "/web";
		this.permissions = new Permissions(this.baseUrl, this._dao);
	};
	
	/**
	 * Retrieves basic information about the site
	 * @returns {Promise<SP.Web>} - A Promise that resolves to an object containing non-deferred properties of SP.Web (https://msdn.microsoft.com/en-us/library/office/jj244873.aspx)
	 * @example
	 * dao.web.info().then(function(info) { console.log(info) });
	 */
	Web.prototype.info = function () {
		return this._dao.get(this.baseUrl).then(utils.validateODataV2);
	};
	
	/**
	 * Retrieves all of the subsites
	 * @returns {Promise<SP.Web[]>} - A Promise that resolves to an array of subsite object, each loaded with all non-deferred properties
	 * @example
	 *  dao.web.subsites().then(function(sites) { console.log(sites) });
	 */
	Web.prototype.subsites = function () {
		return this._dao.get(this.baseUrl + "/webinfos").then(utils.validateODataV2);
	};
	
	/**
	 * Retrieves a token needed to authorize any updates
	 * @return {string} - A Promise that resolves to a the token that needs to added to the "X-RequestDigest" request header
	 * @example
	 *  dao.web.getRequestDigest().then(function(digest) { console.log(digest) });
	 */
	Web.prototype.getRequestDigest = function () {
		return this._dao.getRequestDigest();
	};
	
	/**
	 * Retrieves a folder
	 * @param {string} serverRelativeUrl - The server relative url of the folder
	 * @returns {Promise<Folder>} - A Promise that resolves to a folder object contain a files and folders arrays
	 * @example
	 *  dao.web.getFolder("/sites/mysite/Shared Documents")
	 *			.then(function(folder) { console.log(folder) });
	 */
	Web.prototype.getFolder = function (serverRelativeUrl) {
		//remove leading slash
		if (serverRelativeUrl.charAt(0) === "/") {
			serverRelativeUrl = serverRelativeUrl.substr(1);
		}
		var url = "/web/GetFolderByServerRelativeUrl('" + serverRelativeUrl + "')?$expand=Folders,Files";
	
		return this._dao.get(url).then(utils.validateODataV2).then(function (spFolder) {
			var folder = new Folder(spFolder);
			folder.populateChildren(spFolder);
			return folder;
		});
	};
	
	/**
	 * Uploads a file
	 * @param {HTML5.File|string} fileContent - Either an HTML5 File object (from a File input element) or the string content of the file
	 * @param {string} folderUrl - The server relative folder where the file should be uploaded
	 * @param {object} [[fields]] - An optional object containig the fields that should be set on the file after the upload completes. You can override the filename by passing 'name' property { name: "NewFileName.docx"}
	 * @param {string} [[requestDigest]] - The request digest token used to authorize the request. One will be automatically retrieved if not passed.
	 * @example <caption>Upload files with file input element, assumes <input type='file' id='file-input' /> </caption>
		*var inputElement = document.getElementById("file-input");
		*inputElement.addEventListener("change", handleFiles, false);
		*function handleFiles() {
		*    var fileList = this.files;
		*    var folderUrl = "/spscript/Shared Documents";
		*    for (var i = 0; i < fileList.length; i++) {
		*        dao.web.uploadFile(fileList[i], folderUrl).then(function(result){
		*            console.log(result);
		*        });
		*    }
		*}
	 */
	Web.prototype.uploadFile = function (fileContent, folderUrl, fields, digest) {
		var _this = this;
	
		if (digest) return this._uploadFile(fileContent, folderUrl, fields, digest);
		return this.getRequestDigest().then(function (digest) {
			return _this._uploadFile(fileContent, folderUrl, fields, digest);
		});
	};
	
	Web.prototype._uploadFile = function (fileContent, folderUrl, fields, digest) {
		var _this2 = this;
	
		fields = fields || {};
		// if its a string, just treat that as the raw content
		if (typeof fileContent === "string") {
			fields.name = fields.name || "NewFile.txt";
			return this._uploadBinaryData(fileContent, folderUrl, fields, digest);
		}
	
		// If its a browser File object, use FileReader to get ArrayBuffer
		if (fileContent instanceof File) {
			fields.name = fields.name || fileContent.name;
			return utils.getArrayBuffer(fileContent).then(function (arrayBuffer) {
				return _this2._uploadBinaryData(arrayBuffer, folderUrl, fields, digest);
			});
		}
	};
	
	Web.prototype._setFileFields = function (spFile, fields, digest) {
		var _this3 = this;
	
		// Get the ListItem with ParentList properties so we can query by list title
		return this._dao.get(spFile.__metadata.uri + "/ListItemAllFields?$expand=ParentList").then(utils.validateODataV2).then(function (item) {
			delete fields.name;
			// if there were no fields passed in just return the file and list item
			if (Object.keys(fields).length === 0) {
				return {
					item: item,
					file: spFile
				};
			};
			// If extra fields were passed in, update the list item
			return _this3._dao.lists(item.ParentList.Title).updateItem(item.Id, fields, digest).then(function () {
				item = _extends({}, item, fields);
				return { item: item, file: spFile };
			});
		});
	};
	
	Web.prototype._uploadBinaryData = function (binaryContent, folderUrl, fields, digest) {
		var _this4 = this;
	
		var uploadUrl = "/web/GetFolderByServerRelativeUrl('" + folderUrl + "')/Files/Add(url='" + fields.name + "',overwrite=true)";
		var options = {
			headers: headers.getFilestreamHeaders(digest)
		};
		return this._dao.post(uploadUrl, binaryContent, options).then(utils.validateODataV2).then(function (spFile) {
			return _this4._setFileFields(spFile, fields, digest);
		});
	};
	
	/**
	 * Retrieves a file object
	 * @param {string} url - The server relative url of the file
	 * @returns {Promise<File>} - A Promise that resolves to a file object
	 * @example
	 *  dao.web.getFile("/sites/mysite/Shared Documents/myfile.docx")
	 *			.then(function(file) { console.log(file) });
	 */
	Web.prototype.getFile = function (url) {
		var url = "/web/getfilebyserverrelativeurl('" + url + "')";
		return this._dao.get(url).then(utils.validateODataV2);
	};
	
	/**
	 * Copies a file
	 * @param {string} sourceUrl - The server relative url of the file you want to copy
	 * @param {string} destinationUrl - The server relative url of the destination
	 * @param {string} [[requestDigest]] - The request digest token used to authorize the request. One will be automatically retrieved if not passed.
	 * @example
	 * var sourceFile = "/sites/mysite/Shared Documents/myfile.docx";
	 * var destination = "/sites/mysite/Restricted Docs/myFile.docx";
	 * dao.web.copyFile(sourceFile, destination).then(function() { console.log("Success") });
	 */
	Web.prototype.copyFile = function (sourceUrl, destinationUrl, digest) {
		var _this5 = this;
	
		if (digest) return this._copyFile(sourceUrl, destinationUrl, digest);
	
		return this.getRequestDigest().then(function (requestDigest) {
			return _this5._copyFile(sourceUrl, destinationUrl, requestDigest);
		});
	};
	
	Web.prototype._copyFile = function (sourceUrl, destinationUrl, digest) {
		var url = "/web/getfilebyserverrelativeurl('" + sourceUrl + "')/CopyTo"; //(strnewurl='${destinationUrl}',boverwrite=true)`
		var options = {
			headers: headers.getAddHeaders(digest)
		};
		var body = {
			strNewUrl: destinationUrl,
			bOverWrite: true
		};
		return this._dao.post(url, body, options);
	};
	
	Web.prototype.fileAction = function (file, action) {
		var _this6 = this;
	
		var params = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
		var digest = arguments[3];
	
		if (digest) this._fileAction(file, action, params, digest);
		return this.getRequestDigest().then(function (requestDigest) {
			return _this6._fileAction(file, action, params, requestDigest);
		});
	};
	
	Web.prototype._fileAction = function (file, action, params, digest) {
		var url = "/web/getfilebyserverrelativeurl('" + file + "')/" + action;
		var options = {
			headers: headers.getAddHeaders(digest)
		};
		return this._dao.post(url, params, options);
	};
	
	/**
	 * Deletes a file
	 * @param {string} fileUrl - The server relative url of the file you want to delete
	 * @param {string} [[requestDigest]] - The request digest token used to authorize the request. One will be automatically retrieved if not passed.
	 * @example
	 * dao.web.deleteFile("/sites/mysite/Shared Documents/myFile.docx")
	 *			.then(function() { console.log("Success")});
	 */
	Web.prototype.deleteFile = function (fileUrl, digest) {
		var _this7 = this;
	
		if (digest) return this._deleteFile(fileUrl, digest);
	
		return this.getRequestDigest().then(function (requestDigest) {
			return _this7._deleteFile(fileUrl, requestDigest);
		});
	};
	
	Web.prototype._deleteFile = function (sourceUrl, requestDigest) {
		var url = "/web/getfilebyserverrelativeurl(@url)/?@Url='" + sourceUrl + "'";
		var options = {
			headers: headers.getDeleteHeaders(requestDigest)
		};
		return this._dao.post(url, {}, options);
	};
	
	/**
	 * Retrieves a users object based on an email address
	 * @param {string} email - The email address of the user to retrieve
	 * @returns {Promise<SP.User>} - A Promise that resolves to a an SP.User object
	 * @example
	 * dao.web.getUser("andrew@andrewpetersen.onmicrosoft.com")
	 * 			.then(function(user) { console.log(user)});
	 */
	Web.prototype.getUser = function (email) {
		var url = this.baseUrl + "/SiteUsers/GetByEmail('" + email + "')";
		return this._dao.get(url).then(utils.validateODataV2);
	};
	
	Web.prototype.ensureUser = function (login) {
		return this._dao.post("/web/ensureUser('" + login + "')").then(utils.validateODataV2);
	};
	
	module.exports = Web;
	//# sourceMappingURL=web.js.map

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(40);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./breadcrumb.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./breadcrumb.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(41);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./footer.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./footer.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(42);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./loginPage.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./loginPage.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(43);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./teaserContent.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./teaserContent.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(44);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!./modals.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!./modals.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(54);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// natp.site.js